(function(){
  const $ = (id) => document.getElementById(id);
  const fmt = (n) => `${Math.round(Number(n)||0).toLocaleString()}mm`;
  const pad4 = (n) => String(Math.round(Number(n)||0)).padStart(4,"0");
  const money = (cents) => cents ? new Intl.NumberFormat("en-AU",{style:"currency",currency:"AUD"}).format(cents/100) : "Quote ready";
  const escapeHtml = (value) => String(value ?? "").replace(/[&<>"']/g, ch => ({ "&":"&amp;", "<":"&lt;", ">":"&gt;", "\"":"&quot;", "'":"&#39;" }[ch]));
  const cleanText = (value) => String(value ?? "").replace(/<[^>]*>/g, " ").replace(/&bull;/g, "-").replace(/\s+/g, " ").trim();
  const displaySku = (sku) => {
    const value = String(sku || "").trim();
    return value.startsWith("(GO)") ? value : `(GO) ${value}`;
  };
  function installPreviewGuard(){
    if (document.getElementById("glassBalustradePreviewGuard")) return;
    const style = document.createElement("style");
    style.id = "glassBalustradePreviewGuard";
    style.textContent = ".system-choice .system-preview{display:block!important;opacity:0!important;transform:translateY(4px)!important;pointer-events:none!important}.system-choice.preview-open:not(.active)>.system-preview,.system-choice:focus-visible:not(.active)>.system-preview{opacity:1!important;transform:translateY(0)!important}.system-choice.active>.system-preview{display:none!important;opacity:0!important}";
    document.head.appendChild(style);
  }
  function closeSystemPreviews(except){
    document.querySelectorAll(".system-choice.preview-open").forEach(btn => {
      if (btn !== except) btn.classList.remove("preview-open");
    });
  }
  function installPreviewHover(){
    document.addEventListener("pointerover", (event) => {
      const btn = event.target.closest(".system-choice");
      if (!btn || btn.classList.contains("active")) {
        closeSystemPreviews();
        return;
      }
      closeSystemPreviews(btn);
      btn.classList.add("preview-open");
    });
    document.addEventListener("pointermove", (event) => {
      const btn = document.querySelector(".system-choice.preview-open");
      if (!btn) return;
      const rect = btn.getBoundingClientRect();
      const insideButton = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!insideButton) btn.classList.remove("preview-open");
    });
    document.addEventListener("pointerleave", closeSystemPreviews);
  }
  const stock12 = Array.from({length:25},(_,i)=>300+i*50);
  const stockSemiBalustrade = Array.from({length:25},(_,i)=>300+i*50);
  const stockPinFixed = [400,500,600,700,750,800,850,900,950,1000,1050,1100,1150,1200];
  const stock15 = Array.from({length:23},(_,i)=>300+i*50);
  const finishes = {
    polished:{ label:"Polished", suffix:"P", colour:"#b8c3c1" },
    satin:{ label:"Satin", suffix:"S", colour:"#aab3b1" },
    black:{ label:"Black", suffix:"B", colour:"#14211e" },
    white:{ label:"White", suffix:"W", colour:"#f7f8f5" },
    monument:{ label:"Monument Matt", suffix:"MN", colour:"#3a403c" }
  };
  const skuFinish = () => state.finish === "white" && !isSemiBalustrade() ? "MW" : finishes[state.finish].suffix;
  const state = {
    system:"frameless",
    sideCount:1,
    activeSide:0,
    sides:[
      { runLength:6250 },
      { runLength:3000 },
      { runLength:3000 }
    ],
    runLength:6250,
    glass:"12",
    semiGlass:"12toughened",
    spigot:"nova",
    fixing:"core",
  supportSystem:"two_edge_support",
  handrailProfile:"rectangular",
  semiSiteFixing:"uncracked_concrete",
  pinStandoffType:"fixed",
  pinStandoffDiameter:"50",
  pinStandoffDepth:"30",
  pinHandrail:"deluxe",
  siteLocation:"outdoor",
  windRegion:"A",
  terrainCategory:"2",
  installHeight:"5",
  windClassification:"N3",
  finish:"polished",
  leftEnd:"wall",
  rightEnd:"wall",
  cornerDirections:{
    "0-1":1,
    "1-2":2
  },
  layoutMode:"recommended",
    view:"elevation",
    extras:{ enduroShield:false, groutSika:false, chemset:false, concreteFixings:false }
  };
  const semiBalustrade = {
    systemId:"semi_frameless_balustrade",
    title:"Semi-Frameless Glass Balustrade",
    glassFamilies:{
      "12toughened":{ label:"12mm Toughened", title:"12mm Toughened Heat-Soaked Semi-Frameless Balustrade Glass", thickness:"12mm toughened heat-soaked", glassHeight:970, glassPrefix:"(GO) 970NTG", stock:stockSemiBalustrade, maxPanel:1500 },
      "1152laminated":{ label:"11.52mm Tough Lam", title:"11.52mm Tough Lam Semi-Frameless Balustrade Glass", thickness:"11.52mm tough lam", glassHeight:1000, glassPrefix:"(GO) 1000DG", stock:stockSemiBalustrade, maxPanel:1500 }
    },
    supportSystems:{
      two_edge_support:{ label:"2-Edge Support", handrail:"Australis 75 x 30mm top handrail", capType:"notched", topRubber:false, railPosition:"above" },
      offset_handrail:{ label:"Offset Handrail", handrail:"Australis 50 x 25mm offset handrail", capType:"flat", topRubber:false, railPosition:"offset" },
      three_edge_support:{ label:"3-Edge Support", handrail:"Australis 75 x 30mm top-glazing handrail", capType:"none", topRubber:true, railPosition:"top-glazed" }
    },
    postWidth:50,
    insert:15,
    maxInsert:{ oneWay:27, twoWay:23, corner90:16 },
    siteFixings:{
      cracked_concrete:"Cracked concrete",
      uncracked_concrete:"Uncracked concrete",
      lvl_screw:"LVL screw fixed",
      lvl_bolt:"LVL through-bolted"
    },
    installHeights:{ unsure:"Unsure", "3":"< 3m", "5":"< 5m", "8":"< 8m", "10":"< 10m", "15":"< 15m", "25":"< 25m" },
    spacingTables:{
      cracked_concrete:{
        A:{ "1":{ height:5, spacing:1080 }, "2":{ height:8, spacing:1160 }, "3":{ height:25, spacing:1160 } },
        B:{ "1":{ height:3, spacing:730 }, "2":{ height:5, spacing:830 }, "3":{ height:10, spacing:1000 } }
      },
      uncracked_concrete:{
        A:{ "1":{ height:5, spacing:1360 }, "2":{ height:8, spacing:1400 }, "3":{ height:25, spacing:1400 } },
        B:{ "1":{ height:3, spacing:920 }, "2":{ height:5, spacing:1050 }, "3":{ height:10, spacing:1260 } }
      },
      lvl_screw:{
        A:{ "1":{ height:5, spacing:1090 }, "2":{ height:15, spacing:1090 }, "3":{ height:25, spacing:1090 } },
        B:{ "1":{ height:3, spacing:820 }, "2":{ height:5, spacing:930 }, "3":{ height:10, spacing:1090 } }
      },
      lvl_bolt:{
        A:{ "1":{ height:5, spacing:1140 }, "2":{ height:15, spacing:1140 }, "3":{ height:25, spacing:1140 } },
        B:{ "1":{ height:3, spacing:1120 }, "2":{ height:5, spacing:1140 }, "3":{ height:10, spacing:1140 } }
      }
    },
    postSkus:{
      core:{ oneWay:"A50-1400D-1W", twoWay:"A50-1400D-2W", corner90:"A50-1400-90" },
      base:{ oneWay:"A50-1050D-1WBP", twoWay:"A50-1050D-2WBP", corner90:"A50-1050-90BP" }
    },
    handrailSkus:{
      rectangular:"A50-5800-RHR",
      oval:"A50-5800-OHR",
      offset:"A50-OFF-5800D"
    },
    handrailAccessorySkus:{
      rectangularEnd:"A50-ECA-R",
      ovalEnd:"A50-ECA-O",
      wall:"A50-WP",
      offsetBracket:"A50-OFF-RC",
      offsetCornerBracket:"A50-OFF-RC90",
      offsetJoiner:"A50-OFF-J180-A",
      offsetCornerJoiner:"A50-OFF-J90-A",
      offsetEnd:"A50-OFF-ECAP",
      offsetWall:"A50-OFF-WB",
      handrailPostScrew:"AR-SCR-BR-50PK",
      offsetBracketScrew:"AR-SCR-BAL-100PK",
      offsetHandrailScrew:"VIS-SCR-CSK-50PK"
    },
    capSkus:{
      flat:"XP-TP",
      notchedOneWay:"A5050-TP1W",
      notchedTwoWay:"A5050-TP2W",
      notchedCorner90:"A5050-TP90"
    },
    coverSkus:{
      coreDress:"XP-DR",
      baseDome:"XP-DC-2P"
    },
    accessorySkus:{
      p41:"A50-P41/22-10PK",
      captive:"A50-CAP-YEL-10PK",
      infill:"A50-1400-INF",
      sittingBlock:"A50-SB-20PK",
      fixing:"S-120ROD-4PK"
    },
    notes:[
      "Uses only catalogue semi-frameless balustrade glass families.",
      "Core drill uses 1400mm posts, with Monument 1-way, 2-way and 90-degree profiles supplied as 5800mm lengths; welded base plate uses 1050mm BP posts.",
      "Unmapped post, cap, handrail and accessory variants block checkout until reviewed."
    ]
  };
  const pinFixedBalustrade = {
    systemId:"frameless_pin_fixed_15mm",
    title:"15mm Frameless Pin-Fixed Balustrade",
    glassTitle:"1280mm high 15mm heat-soaked pin-fixed balustrade glass",
    glassHeight:1280,
    glassPrefix:"(GO) 1280S",
    stock:stockPinFixed,
    gap:{ min:10, max:99, preferred:90 },
    standoffs:{
      fixed:{
        "38":{
          "25":{ polished:"GS3825P", satin:"GS3825S", black:"GS3825B", white:"GS3825-MW" },
          "45":{ polished:"GS3845P", satin:"GS3845S", black:"GS3845B", white:"GS3845-MW" }
        },
        "50":{
          "20":{ polished:"GS5020P", satin:"GS5020S", black:"GS5020B" },
          "30":{ polished:"GS5030P", satin:"GS5030S", black:"GS5030B", white:"GS5030-MW" },
          "50":{ polished:"GS5050P", satin:"GS5050S", black:"GS5050B" }
        }
      },
      adjustable:{
        "38":{
          "30":{ polished:"GSA-3830-P", satin:"GSA-3830-S", black:"GSA-3830-B", white:"GSA-3830-MW" },
          "45":{ polished:"GSA-3845-P", satin:"GSA-3845-S", black:"GSA-3845-B", white:"GSA-3845-MW" }
        },
        "50":{
          "30":{ polished:"GSA-5030-P", satin:"GSA-5030-S", black:"GSA-5030-B", white:"GSA-5030-MW" },
          "45":{ polished:"GSA-5045-P", satin:"GSA-5045-S", black:"GSA-5045-B", white:"GSA-5045-MW" }
        }
      }
    },
    handrails:{
      deluxe:{ label:"Deluxe Nanorail", handrail:"Deluxe Nanorail", handrailSku:"NANORAIL-DELUXE", rubberSku:"(GO) STG-DELUXE-GR", notes:["Deluxe Nanorail uses 316L stainless 30 x 21mm rail with 15mm glazing rubber."] },
      series35:{ label:"35 Series", handrail:"35mm Series Aluminium Handrail", handrailSku:"35MM-HANDRAIL", rubberSku:"(GO) SER35-RUB-15MM", notes:["35 Series rail kits include the rail, two end caps and one 5800mm rubber length."] }
    },
    extras:[
      { key:"gs093Lag", sku:"GS093LAG", title:"93mm M12 lag screw", desc:"Optional timber fixing." },
      { key:"gs115Lag", sku:"GS115LAG", title:"115mm M12 lag screw", desc:"Optional timber fixing." },
      { key:"gs160Lag", sku:"GS160LAG", title:"160mm M12 lag screw", desc:"Optional fixing for standard GS fixed standoffs." },
      { key:"gs120Rod", sku:"GS120ROD", title:"120mm M12 threaded rod", desc:"Optional masonry/concrete fixing." },
      { key:"gs1000Rod", sku:"GS1000ROD", title:"1000mm M12 threaded rod", desc:"Optional threaded rod stock length." },
      { key:"soudCa1400", sku:"SOUD-CA1400", title:"Soudal CA-1400 anchoring resin", desc:"Optional anchoring resin." },
      { key:"soudGun", sku:"SOUD-GUN", title:"Applicator gun", desc:"Optional resin applicator gun." },
      { key:"gs38PackingWasher", sku:"GS38W", title:"38mm packing washers", desc:"Optional packing washers for 38mm standoffs.", standoffDiameter:"38" },
      { key:"gs50PackingWasher", sku:"GS50W", title:"50mm packing washers", desc:"Optional packing washers for 50mm standoffs.", standoffDiameter:"50" },
      { key:"gsDomeNuts", sku:"GS-DN-4PK", title:"Dome nuts and split washers", desc:"Optional dome nut and split washer pack." },
      { key:"gsDomeNutsBlack", sku:"GS-DN-4PK-B", title:"Black dome nuts and split washers", desc:"Optional black dome nut and split washer pack." }
    ]
  };
  const rules = {
    "12-nova":{
      title:"12mm Heat-Soaked Frameless Glass",
      glassHeight:970,
      glassPrefix:"(GO) 970NTG",
      stock:stock12,
      maxPanel:1500,
      spigotName:"Nova",
      handrail:"Standard Nanorail",
      handrailSku:"NANORAIL-STD",
      rubberSku:"(GO) STG-NANO-GR",
      gap:{ min:10, max:99, preferred:90 },
      openEndMax:550,
      notes:["Nova uses the 12mm Standard Nanorail system.","Open-end Standard Nanorail layouts keep end panels at 550mm or less.","Layouts aim for gaps under 100mm where possible."]
    },
    "12-madrid":{
      title:"12mm Heat-Soaked Frameless Glass",
      glassHeight:970,
      glassPrefix:"(GO) 970NTG",
      stock:stock12,
      maxPanel:1500,
      spigotName:"Madrid Standard",
      handrail:"Standard Nanorail",
      handrailSku:"NANORAIL-STD",
      rubberSku:"(GO) STG-NANO-GR",
      gap:{ min:10, max:99 },
      maxReviewedSpan:4880,
      notes:["Madrid Standard uses the 12mm Standard Nanorail system.","Runs over 4,880mm should be reviewed before online ordering.","Layouts aim for gaps under 100mm where possible."]
    },
    "15-madridDeluxe":{
      title:"15mm Heat-Soaked Frameless Glass",
      glassHeight:1000,
      glassPrefix:"(GO) 1000FBG",
      stock:stock15,
      maxPanel:1400,
      spigotName:"Madrid Deluxe",
      handrail:"Deluxe Nanorail",
      handrailSku:"NANORAIL-DELUXE",
      rubberSku:"(GO) STG-DELUXE-GR",
      gap:{ min:10, max:99 },
      notes:["15mm glass automatically uses Madrid Deluxe spigots and Deluxe Nanorail.","V1 uses stock glass up to 1400mm wide.","Layouts aim for gaps under 100mm where possible."]
    }
  };
  const spigotSkus = {
    nova:{
      core:{
        polished:"(GO) NOV-S-P + NOV-DR-P",
        satin:"(GO) NOV-S-S + NOV-DR-S",
        black:"(GO) NOV-S-B + NOV-DR-B",
        white:"(GO) NOV-S-MW + NOV-DR-MW"
      },
      base:{
        polished:"(GO) NOV-SBP-P + NOV-HDC-P",
        satin:"(GO) NOV-SBP-S + NOV-HDC-S",
        black:"(GO) NOV-SBP-B + NOV-HDC-B",
        white:"(GO) NOV-SBP-MW + NOV-HDC-MW"
      }
    },
    madrid:{
      core:{
        polished:"(GO) MAD-S-P + MAD-DR-P",
        satin:"(GO) MAD-S-S + MAD-DR-S",
        black:"(GO) MAD-S-B + MAD-DR-B",
        white:"(GO) MAD-S-MW + MAD-DR-MW"
      },
      base:{
        polished:"(GO) MAD-SBP-P + MAD-SDC-P",
        satin:"(GO) MAD-SBP-S + MAD-SDC-S",
        black:"(GO) MAD-SBP-B + MAD-SDC-B",
        white:"(GO) MAD-SBP-MW + MAD-SDC-MW"
      }
    },
    madridDeluxe:{
      core:{
        polished:"(GO) MADDEL-S-P + MADDEL-DR-P",
        satin:"(GO) MADDEL-S-S + MADDEL-DR-S",
        black:"(GO) MADDEL-S-B + MADDEL-DR-B",
        white:"(GO) MADDEL-S-MW + MADDEL-DR-MW"
      },
      base:{
        polished:"(GO) MADDEL-SBP-P + MADDEL-HDC-P",
        satin:"(GO) MADDEL-SBP-S + MADDEL-HDC-S",
        black:"(GO) MADDEL-SBP-B + MADDEL-HDC-B",
        white:"(GO) MADDEL-SBP-MW + MADDEL-HDC-MW"
      }
    }
  };
  const accessorySkus = {
    novaDress:"NOVA-DR",
    novaDome:"NOVA-DC",
    stdWall:"(GO) STG-2521-WPEXT",
    stdCap:"(GO) STG-2521-EC",
    dlxWall:"(GO) STG-DELUXE-WPEXT",
    dlxCap:"(GO) STG-DELUXE-EC",
    joinerStd:"(GO) STG-2521-J",
    joinerDlx:"(GO) STG-DELUXE-J",
    joiner35:{ default:"(GO) SER35-J-SA" },
    cornerStd:"(GO) STG-2521-90J",
    cornerDlx:"(GO) STG-DELUXE-90J",
    corner35:{ default:"(GO) SER35-J90-SA" },
    railStd:"(GO) STG-R5800-2521",
    railDlx:"(GO) STG-R5800-DELUXE",
    rail35:"(GO) SER35-R5800",
    rail35Wall:"(GO) SER35-WBEXT",
    rail35Cap:"(GO) SER35-EC"
  };
  const defaultVariantMap = {
    "(GO) NOV-S-P + NOV-DR-P":{ variantId:51618824847671 },
    "(GO) NOV-S-S + NOV-DR-S":{ variantId:51618824880439 },
    "(GO) NOV-S-B + NOV-DR-B":{ variantId:51618824913207 },
    "(GO) NOV-S-MW + NOV-DR-MW":{ variantId:51618824945975 },
    "(GO) NOV-SBP-P + NOV-HDC-P":{ variantId:51618824454455 },
    "(GO) NOV-SBP-S + NOV-HDC-S":{ variantId:51618824487223 },
    "(GO) NOV-SBP-B + NOV-HDC-B":{ variantId:51618824519991 },
    "(GO) NOV-SBP-MW + NOV-HDC-MW":{ variantId:51618824552759 },
    "(GO) MADDEL-SBP-P + MADDEL-HDC-P":{ variantId:39728927703143 },
    "(GO) MADDEL-SBP-S + MADDEL-HDC-S":{ variantId:39728927735911 },
    "(GO) MADDEL-SBP-B + MADDEL-HDC-B":{ variantId:48945992925495 },
    "(GO) MADDEL-SBP-MW + MADDEL-HDC-MW":{ variantId:48945992958263 },
    "(GO) MADDEL-S-P + MADDEL-DR-P":{ variantId:39729471127655 },
    "(GO) MADDEL-S-S + MADDEL-DR-S":{ variantId:39729471160423 },
    "(GO) MADDEL-S-B + MADDEL-DR-B":{ variantId:48945962549559 },
    "(GO) MADDEL-S-MW + MADDEL-DR-MW":{ variantId:48945962582327 },
    "(GO) MAD-S-B + MAD-DR-B":{ variantId:51618820423991 },
    "(GO) MAD-SBP-B + MAD-SDC-B":{ variantId:51618820456759 },
    "(GO) MAD-S-P + MAD-DR-P":{ variantId:51618820489527 },
    "(GO) MAD-SBP-P + MAD-SDC-P":{ variantId:51618820522295 },
    "(GO) MAD-S-S + MAD-DR-S":{ variantId:51618820555063 },
    "(GO) MAD-SBP-S + MAD-SDC-S":{ variantId:51618820587831 },
    "(GO) MAD-S-MW + MAD-DR-MW":{ variantId:44110236680503 },
    "(GO) MAD-SBP-MW + MAD-SDC-MW":{ variantId:51618820620599 },
    "(GO) STG-R5800-2521-P":{ variantId:32042984833127 },
    "(GO) STG-R5800-2521-S":{ variantId:32042984865895 },
    "(GO) STG-R5800-2521-B":{ variantId:32042984898663 },
    "(GO) STG-R5800-2521-MW":{ variantId:44761515229495 },
    "(GO) STG-2521-J-P":{ variantId:39362447933543 },
    "(GO) STG-2521-J-S":{ variantId:39362447966311 },
    "(GO) STG-2521-J-B":{ variantId:39363817701479 },
    "(GO) STG-2521-J-MW":{ variantId:49902233977143 },
    "(GO) STG-2521-90J-P":{ variantId:39362447999079 },
    "(GO) STG-2521-90J-S":{ variantId:39362448031847 },
    "(GO) STG-2521-90J-B":{ variantId:39364401758311 },
    "(GO) STG-2521-90J-MW":{ variantId:44755290063159 },
    "(GO) STG-2521-VJA-MW":{ variantId:44742799163703 },
    "(GO) STG-2521-WPEXT-P":{ variantId:39364345266279 },
    "(GO) STG-2521-WPEXT-S":{ variantId:39364345299047 },
    "(GO) STG-2521-WPEXT-B":{ variantId:39364345331815 },
    "(GO) STG-2521-WPEXT-MW":{ variantId:44755505643831 },
    "(GO) STG-2521-EC-P":{ variantId:39362448195687 },
    "(GO) STG-2521-EC-S":{ variantId:39362448228455 },
    "(GO) STG-2521-EC-B":{ variantId:39364402020455 },
    "(GO) STG-2521-EC-MW":{ variantId:44755329188151 },
    "(GO) STG-R5800-DELUXE-P":{ variantId:48957494985015 },
    "(GO) STG-R5800-DELUXE-S":{ variantId:48957504520503 },
    "(GO) STG-DELUXE-J-P":{ variantId:48954341753143 },
    "(GO) STG-DELUXE-J-S":{ variantId:48954350403895 },
    "(GO) STG-DELUXE-WPEXT-P":{ variantId:48954375962935 },
    "(GO) STG-DELUXE-WPEXT-S":{ variantId:48954413875511 },
    "(GO) STG-DELUXE-WP-P":{ variantId:48954358038839 },
    "(GO) STG-DELUXE-WP-S":{ variantId:48954366460215 },
    "(GO) STG-DELUXE-EC-P":{ variantId:48954272022839 },
    "(GO) STG-DELUXE-EC-S":{ variantId:48954297188663 },
    "(GO) STG-DELUXE-90J-P":{ variantId:48954184433975 },
    "(GO) STG-DELUXE-90J-S":{ variantId:48954237583671 },
    "(GO) STG-DELUXE-VJA-P":{ variantId:51618825175351 },
    "(GO) STG-DELUXE-VJA-S":{ variantId:51618825240887 },
    "(GO) STG-DELUXE-HJA-P":{ variantId:48954322977079 },
    "(GO) STG-DELUXE-HJA-S":{ variantId:48954331038007 },
    "(GO) STG-DELUXE-GR":{ variantId:48954308788535 },
    "(GO) 1280S-0400":{ variantId:49593947717943 },
    "(GO) 1280S-0500":{ variantId:49593947750711 },
    "(GO) 1280S-0600":{ variantId:49593947783479 },
    "(GO) 1280S-0700":{ variantId:49593947816247 },
    "(GO) 1280S-0750":{ variantId:49593947849015 },
    "(GO) 1280S-0800":{ variantId:49593947881783 },
    "(GO) 1280S-0850":{ variantId:49593947914551 },
    "(GO) 1280S-0900":{ variantId:49593947947319 },
    "(GO) 1280S-0950":{ variantId:49593947980087 },
    "(GO) 1280S-1000":{ variantId:49593948012855 },
    "(GO) 1280S-1050":{ variantId:49593948045623 },
    "(GO) 1280S-1100":{ variantId:49593948078391 },
    "(GO) 1280S-1150":{ variantId:49593948111159 },
    "(GO) 1280S-1200":{ variantId:49593948143927 },
    "GS3825P":{ variantId:29977874104423 },
    "GS3825S":{ variantId:29977874169959 },
    "GS3825B":{ variantId:29977906249831 },
    "GS3845P":{ variantId:29977874137191 },
    "GS3845S":{ variantId:29977874202727 },
    "GS3845B":{ variantId:29977906315367 },
    "GS5020P":{ variantId:32913430216807 },
    "GS5020S":{ variantId:32913430249575 },
    "GS5020B":{ variantId:32913430282343 },
    "GS5030P":{ variantId:29977874235495 },
    "GS5030S":{ variantId:29977874301031 },
    "GS5030B":{ variantId:29977906380903 },
    "GS5050P":{ variantId:29977874268263 },
    "GS5050S":{ variantId:29977874333799 },
    "GS5050B":{ variantId:29977906446439 },
    "GSA-3830-P":{ variantId:49796014178615 },
    "GSA-3830-S":{ variantId:49796014211383 },
    "GSA-3830-B":{ variantId:49796028694839 },
    "GSA-3830-MW":{ variantId:49796028727607 },
    "GSA-3845-P":{ variantId:49796162421047 },
    "GSA-3845-S":{ variantId:49796162453815 },
    "GSA-3845-B":{ variantId:49796162486583 },
    "GSA-3845-MW":{ variantId:49796162519351 },
    "GSA-5030-P":{ variantId:49796364730679 },
    "GSA-5030-S":{ variantId:49796364763447 },
    "GSA-5030-B":{ variantId:49796364796215 },
    "GSA-5030-MW":{ variantId:49796364828983 },
    "GSA-5045-P":{ variantId:49796476043575 },
    "GSA-5045-S":{ variantId:49796476076343 },
    "GSA-5045-B":{ variantId:49796476109111 },
    "GSA-5045-MW":{ variantId:49796476141879 },
    "(GO) SER35-R5800-B":{ variantId:49892756390199 },
    "(GO) SER35-R5800-MW":{ variantId:49892926259511 },
    "(GO) SER35-R5800-M":{ variantId:49892905320759 },
    "(GO) SER35-R5800-SA":{ variantId:49893417287991 },
    "(GO) SER35-WB-M":{ variantId:49893652988215 },
    "(GO) SER35-WB-B":{ variantId:49893625725239 },
    "(GO) SER35-WB-MW":{ variantId:49893710856503 },
    "(GO) SER35-WBEXT-B":{ variantId:49893825478967 },
    "(GO) SER35-WBEXT-MW":{ variantId:49893897896247 },
    "(GO) SER35-WBEXT-S":{ variantId:49894000460087 },
    "(GO) SER35-EC-B":{ variantId:49892369563959 },
    "(GO) SER35-EC-MW":{ variantId:49892587700535 },
    "(GO) SER35-EC-SA":{ variantId:49892609392951 },
    "(GO) SER35-J-SA":{ variantId:49892677681463 },
    "(GO) SER35-J90-SA":{ variantId:49892718739767 },
    "(GO) SER35-RUB-15MM":{ variantId:49893481021751 },
    "(GO) 970NTG-0300":{ variantId:29952419496039 },
    "(GO) 970NTG-0350":{ variantId:29952419528807 },
    "(GO) 970NTG-0400":{ variantId:29952419561575 },
    "(GO) 970NTG-0450":{ variantId:29952419594343 },
    "(GO) 970NTG-0500":{ variantId:29952419627111 },
    "(GO) 970NTG-0550":{ variantId:29952419659879 },
    "(GO) 970NTG-0600":{ variantId:29952419692647 },
    "(GO) 970NTG-0650":{ variantId:29952419725415 },
    "(GO) 970NTG-0700":{ variantId:29952419758183 },
    "(GO) 970NTG-0750":{ variantId:29952419790951 },
    "(GO) 970NTG-0800":{ variantId:29952419823719 },
    "(GO) 970NTG-0850":{ variantId:29952419856487 },
    "(GO) 970NTG-0900":{ variantId:29952419889255 },
    "(GO) 970NTG-0950":{ variantId:29952419922023 },
    "(GO) 970NTG-1000":{ variantId:29952419954791 },
    "(GO) 970NTG-1050":{ variantId:29952419987559 },
    "(GO) 970NTG-1100":{ variantId:29952420020327 },
    "(GO) 970NTG-1150":{ variantId:29952420053095 },
    "(GO) 970NTG-1200":{ variantId:29952420085863 },
    "(GO) 970NTG-1250":{ variantId:29952420118631 },
    "(GO) 970NTG-1300":{ variantId:29952420151399 },
    "(GO) 970NTG-1350":{ variantId:29952420184167 },
    "(GO) 970NTG-1400":{ variantId:29952420216935 },
    "(GO) 970NTG-1450":{ variantId:29952420249703 },
    "(GO) 970NTG-1500":{ variantId:29952420282471 },
    "(GO) 970NTG-1550":{ variantId:29952420315239 },
    "(GO) 970NTG-1600":{ variantId:29952420348007 },
    "(GO) 970NTG-1650":{ variantId:29952420380775 },
    "(GO) 970NTG-1700":{ variantId:29952420413543 },
    "(GO) 970NTG-1750":{ variantId:29952420446311 },
    "(GO) 970NTG-1800":{ variantId:29952420479079 },
    "(GO) 1000FBG-0300":{ variantId:48914480365879 },
    "(GO) 1000FBG-0350":{ variantId:48914480398647 },
    "(GO) 1000FBG-0400":{ variantId:48914480431415 },
    "(GO) 1000FBG-0450":{ variantId:48914480464183 },
    "(GO) 1000FBG-0500":{ variantId:48914480496951 },
    "(GO) 1000FBG-0550":{ variantId:48914480529719 },
    "(GO) 1000FBG-0600":{ variantId:48914480562487 },
    "(GO) 1000FBG-0650":{ variantId:48914480595255 },
    "(GO) 1000FBG-0700":{ variantId:48914480628023 },
    "(GO) 1000FBG-0750":{ variantId:48914480660791 },
    "(GO) 1000FBG-0800":{ variantId:48914480693559 },
    "(GO) 1000FBG-0850":{ variantId:48914480726327 },
    "(GO) 1000FBG-0900":{ variantId:48914480759095 },
    "(GO) 1000FBG-0950":{ variantId:48914480791863 },
    "(GO) 1000FBG-1000":{ variantId:48914480857399 },
    "(GO) 1000FBG-1050":{ variantId:48914480890167 },
    "(GO) 1000FBG-1100":{ variantId:48914480922935 },
    "(GO) 1000FBG-1150":{ variantId:48914480955703 },
    "(GO) 1000FBG-1200":{ variantId:48914480988471 },
    "(GO) 1000FBG-1250":{ variantId:48914481021239 },
    "(GO) 1000FBG-1300":{ variantId:48914481054007 },
    "(GO) 1000FBG-1350":{ variantId:48914481086775 },
    "(GO) 1000FBG-1400":{ variantId:48914481119543 },
    "(GO) 1000DG-0300":{ variantId:45518643527991 },
    "(GO) 1000DG-0350":{ variantId:45518643560759 },
    "(GO) 1000DG-0400":{ variantId:45518643593527 },
    "(GO) 1000DG-0450":{ variantId:45518643626295 },
    "(GO) 1000DG-0500":{ variantId:45518643659063 },
    "(GO) 1000DG-0550":{ variantId:45518643691831 },
    "(GO) 1000DG-0600":{ variantId:45518643724599 },
    "(GO) 1000DG-0650":{ variantId:45518643757367 },
    "(GO) 1000DG-0700":{ variantId:45518643790135 },
    "(GO) 1000DG-0750":{ variantId:45518643822903 },
    "(GO) 1000DG-0800":{ variantId:45518643855671 },
    "(GO) 1000DG-0850":{ variantId:45518643888439 },
    "(GO) 1000DG-0900":{ variantId:45518643921207 },
    "(GO) 1000DG-0950":{ variantId:45518643953975 },
    "(GO) 1000DG-1000":{ variantId:45518643986743 },
    "(GO) 1000DG-1050":{ variantId:45518644019511 },
    "(GO) 1000DG-1100":{ variantId:45518644052279 },
    "(GO) 1000DG-1150":{ variantId:45518644085047 },
    "(GO) 1000DG-1200":{ variantId:45518644117815 },
    "(GO) 1000DG-1250":{ variantId:45518644150583 },
    "(GO) 1000DG-1300":{ variantId:45518644183351 },
    "(GO) 1000DG-1350":{ variantId:45518644216119 },
    "(GO) 1000DG-1400":{ variantId:45518644248887 },
    "(GO) 1000DG-1450":{ variantId:45518644281655 },
    "(GO) 1000DG-1500":{ variantId:45518644314423 },
    "(GO) STG-NANO-GR":{ variantId:39362448326759 },
    "A50-1400D-1W-B":{ variantId:39534441857127 },
    "A50-1400D-1W-M":{ variantId:39534441922663 },
    "A50-1400D-1W-W":{ variantId:39534441955431 },
    "A50-1400D-2W-B":{ variantId:39534444380263 },
    "A50-1400D-2W-M":{ variantId:39534444445799 },
    "A50-1400D-2W-W":{ variantId:39534444478567 },
    "A50-1400-90-B":{ variantId:39534457192551 },
    "A50-1400-90-M":{ variantId:39534457225319 },
    "A50-1400-90-W":{ variantId:39534457258087 },
    "A50-1400D-HALF-B":{ variantId:47122558222647 },
    "A50-1400D-HALF-MN":{ variantId:47122558288183 },
    "A50-1400D-HALF-M":{ variantId:47122558320951 },
    "A50-1400D-HALF-W":{ variantId:47122558255415 },
    "A50-5800D-1W-MN":{ variantId:44728221368631 },
    "A50-5800D-2W-MN":{ variantId:44728271012151 },
    "A50-5800-90-MN":{ variantId:44728365285687 },
    "A50-5800-135-B":{ variantId:48152334336311 },
    "A50-5800-135-MN":{ variantId:48152334369079 },
    "A50-5800-135-M":{ variantId:48152334434615 },
    "A50-5800-135-W":{ variantId:48152334401847 },
    "A50-1050D-1WBP-B":{ variantId:39362461401191 },
    "A50-1050D-1WBP-MN":{ variantId:51025574297911 },
    "A50-1050D-1WBP-W":{ variantId:51025574265143 },
    "A50-1050D-2WBP-B":{ variantId:39362461499495 },
    "A50-1050D-2WBP-MN":{ variantId:51025583014199 },
    "A50-1050D-2WBP-M":{ variantId:39362461565031 },
    "A50-1050D-2WBP-W":{ variantId:51025582981431 },
    "A50-1050-90BP-B":{ variantId:39362461597799 },
    "A50-1050-90BP-MN":{ variantId:50503853277495 },
    "A50-1050-90BP-M":{ variantId:39362461663335 },
    "A50-1050-90BP-W":{ variantId:51025592385847 },
    "XP-DR-B":{ variantId:32977495064679 },
    "XP-DR-MN":{ variantId:44585918759223 },
    "XP-DR-W":{ variantId:32977495162983 },
    "XP-DR-M":{ variantId:32977495195751 },
    "A50-DC-B":{ variantId:32915586580583 },
    "A50-DC-M":{ variantId:32915586646119 },
    "XP-DC-2P-B":{ variantId:32977494900839 },
    "XP-DC-2P-MN":{ variantId:32977494966375 },
    "XP-DC-2P-W":{ variantId:32977494999143 },
    "XP-DC-2P-M":{ variantId:32977495031911 },
    "XP-TP-B":{ variantId:32977495556199 },
    "XP-TP-MN":{ variantId:44586046849335 },
    "XP-TP-W":{ variantId:32977495654503 },
    "XP-TP-M":{ variantId:32977495720039 },
    "A50-1400-INF-B":{ variantId:32915559678055 },
    "A50-1400-INF-MN":{ variantId:32915559710823 },
    "A50-1400-INF-W":{ variantId:44728603083063 },
    "A50-1400-INF-M":{ variantId:32915559743591 },
    "A50-5800-RHR-B":{ variantId:45118279319863 },
    "A50-5800-RHR-MN":{ variantId:45118279352631 },
    "A50-5800-RHR-W":{ variantId:45118279385399 },
    "A50-5800-RHR-M":{ variantId:45118279418167 },
    "A50-5800-OHR-B":{ variantId:45118322802999 },
    "A50-5800-OHR-MN":{ variantId:45118322835767 },
    "A50-5800-OHR-W":{ variantId:45118322868535 },
    "A50-5800-OHR-M":{ variantId:45118322901303 },
    "A50-ECA-R-B":{ variantId:45119065850167 },
    "A50-ECA-R-MN":{ variantId:45119065882935 },
    "A50-ECA-R-W":{ variantId:45119065915703 },
    "A50-ECA-R-M":{ variantId:45119065948471 },
    "A50-ECA-O-B":{ variantId:45119320490295 },
    "A50-ECA-O-MN":{ variantId:45119320523063 },
    "A50-ECA-O-W":{ variantId:45119320555831 },
    "A50-ECA-O-M":{ variantId:45119320588599 },
    "A50-WP-B":{ variantId:45119537250615 },
    "A50-WP-MN":{ variantId:45119537283383 },
    "A50-WP-W":{ variantId:45119537316151 },
    "A50-WP-M":{ variantId:45119537348919 },
    "A50-OFF-5800D-B":{ variantId:39362462777447 },
    "A50-OFF-5800D-MN":{ variantId:39362462810215 },
    "A50-OFF-5800D-W":{ variantId:50417695392055 },
    "A50-OFF-RC-B":{ variantId:39362463400039 },
    "A50-OFF-RC-MN":{ variantId:39362463432807 },
    "A50-OFF-RC-W":{ variantId:39362463465575 },
    "A50-OFF-RC-SWIV-M":{ variantId:51618820129079 },
    "A50-OFF-RC90-B":{ variantId:39362463498343 },
    "A50-OFF-RC90-MN":{ variantId:49145886540087 },
    "A50-OFF-RC90-W":{ variantId:39362463531111 },
    "A50-OFF-RC90-M":{ variantId:39362463563879 },
    "A50-OFF-ECAP-B":{ variantId:49366334472503 },
    "A50-OFF-ECAP-MN":{ variantId:49366377365815 },
    "A50-OFF-ECAP-W":{ variantId:49366385819959 },
    "A50-OFF-ECAP-M":{ variantId:49366351118647 },
    "A50-OFF-WB-B":{ variantId:39362463596647 },
    "A50-OFF-WB-MN":{ variantId:39362463629415 },
    "A50-OFF-WB-W":{ variantId:39362463662183 },
    "A50-OFF-WB-M":{ variantId:51025637441847 },
    "A50-OFF-J180-A":{ variantId:52933427659063 },
    "A50-OFF-J90-A":{ variantId:49999498379575 },
    "A5050-TP1W-B":{ variantId:52937615442231 },
    "A5050-TP1W-MN":{ variantId:52937615474999 },
    "A5050-TP1W-M":{ variantId:52937615507767 },
    "A5050-TP1W-W":{ variantId:52937615540535 },
    "A5050-TP2W-B":{ variantId:52937615573303 },
    "A5050-TP2W-MN":{ variantId:52937615606071 },
    "A5050-TP2W-M":{ variantId:52937615638839 },
    "A5050-TP2W-W":{ variantId:52937615671607 },
    "A5050-TP90-B":{ variantId:52937615704375 },
    "A5050-TP90-MN":{ variantId:52937615737143 },
    "A5050-TP90-M":{ variantId:52937615769911 },
    "A5050-TP90-W":{ variantId:52937615802679 },
    "AR-SCR-BR-50PK-B":{ variantId:45130733519159 },
    "AR-SCR-BR-50PK-W":{ variantId:45130733584695 },
    "AR-SCR-BR-50PK":{ variantId:45130733617463 },
    "AR-SCR-BAL-100PK":{ variantId:46862357332279 },
    "VIS-SCR-CSK-50PK-B":{ variantId:47112973287735 },
    "VIS-SCR-CSK-50PK-W":{ variantId:47112973320503 },
    "VIS-SCR-CSK-50PK":{ variantId:47112973254967 },
    "A50-P41/22-10PK":{ variantId:32915609419879 },
    "A50-CAP-YEL-10PK":{ variantId:29974781788263 },
    "A50-SB-20PK":{ variantId:32913049452647 },
    "(GO) GS093LAG":{ variantId:29952223281255 },
    "GS093LAG":{ variantId:29952223281255 },
    "(GO) GS115LAG":{ variantId:29952223314023 },
    "GS115LAG":{ variantId:29952223314023 },
    "(GO) GS160LAG":{ variantId:29952223346791 },
    "GS160LAG":{ variantId:29952223346791 },
    "(GO) GS120ROD":{ variantId:32913045684327 },
    "GS120ROD":{ variantId:32913045684327 },
    "(GO) GS1000ROD":{ variantId:32913045717095 },
    "GS1000ROD":{ variantId:32913045717095 },
    "(GO) SOUD-CA1400":{ variantId:32913045586023 },
    "(GO) SOUD-GUN":{ variantId:32913052139623 },
    "SOUD-GUN":{ variantId:32913052139623 },
    "(GO) GS38W":{ variantId:32913048567911 },
    "GS38W":{ variantId:32913048567911 },
    "(GO) GS50W":{ variantId:32913048600679 },
    "GS50W":{ variantId:32913048600679 },
    "(GO) GS-DN-4PK":{ variantId:32913048764519 },
    "GS-DN-4PK":{ variantId:32913048764519 },
    "(GO) GS-DN-4PK-B":{ variantId:47113123692855 },
    "GS-DN-4PK-B":{ variantId:47113123692855 },
    "FACTORY-ENDUROSHIELD":{ variantId:52468851540279, price:6500 },
    "GROUT-SIKA":{ variantId:29945218302055, price:4500 },
    "SOUD-CA1400":{ variantId:32913045586023, price:2500 },
    "CONCRETE-FIX-KIT":{ variantId:32913046503527, price:600 },
    "S-120ROD-4PK":{ variantId:32913046503527, price:600 }
  };
  const variantMap = { ...defaultVariantMap, ...(window.GLASS_BALUSTRADE_VARIANT_MAP || {}) };
  const priceFetchAttempts = new Set();
  let priceFetchTimer = 0;
  function estimateLinePrice(line){
    const sku = String(line.sku || "");
    const name = String(line.name || "");
    const qty = Number(line.qty) || 0;
    const width = Number((sku.match(/-(\d{4})$/) || name.match(/(\d{3,4})mm/) || [0,0])[1]) || 0;
    if (!qty) return 0;
    if (line.unit === "m2" || sku === "FACTORY-ENDUROSHIELD") return qty * 6500;
    if (sku.includes("970NTG")) return qty * Math.max(18000, width * 42);
    if (sku.includes("1000FBG")) return qty * Math.max(26000, width * 62);
    if (sku.includes("NOV-") || sku.includes("MAD-") || sku.includes("MADDEL-")) return qty * (sku.includes("DEL") ? 13500 : 9500);
    if (sku.includes("A50-1050")) return qty * 14500;
    if (sku.includes("A50-P41/22") || sku.includes("A50-CAP-YEL")) return qty * 4500;
    if (sku.includes("R5800")) return qty * (sku.includes("DELUXE") ? 39000 : 29000);
    if (sku.includes("RUB") || sku.includes("GR")) return qty * 4500;
    if (sku.includes("WPEXT") || sku.includes("EC") || sku.includes("90J") || sku.includes("-J-")) return qty * 4500;
    if (sku === "GROUT-SIKA") return qty * 4500;
    if (sku === "SOUD-CA1400") return qty * 2500;
    if (sku === "CONCRETE-FIX-KIT" || sku === "S-120ROD-4PK") return qty * 600;
    return qty * 5000;
  }
  async function fetchVariantPrice(variantId){
    const id = String(variantId || "");
    if (!id || priceFetchAttempts.has(id)) return null;
    priceFetchAttempts.add(id);
    try {
      const root = window.Shopify?.routes?.root || "/";
      const response = await fetch(`${root}variants/${id}.js`, { headers:{ "Accept":"application/json" } });
      if (!response.ok) return null;
      const variant = await response.json();
      const price = Number(variant?.price);
      return Number.isFinite(price) && price > 0 ? price : null;
    } catch {
      return null;
    }
  }
  function queueVariantPriceRefresh(lines){
    if (location.protocol === "file:" || priceFetchTimer) return;
    const missingPrices = lines
      .map(line => variantMap[line.sku])
      .filter(mapped => mapped?.variantId && !Number(mapped.price) && !priceFetchAttempts.has(String(mapped.variantId)));
    if (!missingPrices.length) return;
    priceFetchTimer = window.setTimeout(async () => {
      priceFetchTimer = 0;
      await Promise.all(missingPrices.map(async mapped => {
        const price = await fetchVariantPrice(mapped.variantId);
        if (price) mapped.price = price;
      }));
      render();
    }, 100);
  }

  function activeSide(){
    return state.sides[state.activeSide] || state.sides[0];
  }
  function isSemiBalustrade(){
    return state.system === semiBalustrade.systemId;
  }
  function isPinFixedBalustrade(){
    return state.system === pinFixedBalustrade.systemId;
  }
  function syncActiveSide(){
    state.activeSide = Math.max(0, Math.min(Number(state.activeSide)||0, state.sideCount-1));
    state.runLength = Number(activeSide().runLength) || state.runLength || 6250;
  }
function effectiveEnd(sideIndex, end){
  if (end === "left" && sideIndex > 0) return "connected";
  if (end === "right" && sideIndex < state.sideCount - 1) return "connected";
  return end === "left" ? state.leftEnd : state.rightEnd;
}

function cornerKey(firstSideIndex){
  return `${firstSideIndex}-${firstSideIndex + 1}`;
}

function cornerInsideSide(firstSideIndex){
  const stored = Number(state.cornerDirections?.[cornerKey(firstSideIndex)]);
  return stored === firstSideIndex || stored === firstSideIndex + 1
    ? stored
    : firstSideIndex + 1;
}

function endNeedsGapForSide(sideIndex, end){
  const type = effectiveEnd(sideIndex, end);
  if (type === "wall") return true;
  if (type !== "connected") return false;
  const neighbour = end === "right" ? sideIndex + 1 : sideIndex - 1;
  const firstSideIndex = Math.min(sideIndex, neighbour);
  return cornerInsideSide(firstSideIndex) === sideIndex;
}

function elevationShouldReverse(sideIndex = state.activeSide){
  if (state.sideCount === 2) return true;
  return state.sideCount >= 3 && sideIndex === 2;
}
  function isUnsure(value){
    return String(value || "").toLowerCase() === "unsure";
  }
  function semiNeedsLaminatedGlass(){
    if (state.siteLocation === "indoor") return isUnsure(state.installHeight) || (Number(state.installHeight) || 0) > 5;
    return isUnsure(state.windRegion) || isUnsure(state.terrainCategory) || isUnsure(state.installHeight) || (Number(state.installHeight) || 0) > 5;
  }
  function isMadridDeluxeFrameless(){
    return !isSemiBalustrade() && !isPinFixedBalustrade() && state.glass === "15";
  }
  function isMadridStandardFrameless(){
    return !isSemiBalustrade() && !isPinFixedBalustrade() && state.glass === "12" && state.spigot === "madrid";
  }
  function isNovaFrameless(){
    return !isSemiBalustrade() && !isPinFixedBalustrade() && state.glass === "12" && state.spigot === "nova";
  }
  function isHeightLimitedFrameless(){
    return isMadridDeluxeFrameless() || isMadridStandardFrameless() || isNovaFrameless() || isPinFixedBalustrade();
  }
  function normaliseSiteState(){
    state.siteLocation = state.siteLocation === "indoor" ? "indoor" : "outdoor";
    state.windRegion = isUnsure(state.windRegion) ? "unsure" : ["A","B","C","D"].includes(String(state.windRegion).toUpperCase()) ? String(state.windRegion).toUpperCase() : "A";
    state.terrainCategory = isUnsure(state.terrainCategory) ? "unsure" : ["1","2","3"].includes(String(state.terrainCategory)) ? String(state.terrainCategory) : "2";
    state.installHeight = isUnsure(state.installHeight) ? "unsure" : ["3","5","8","10","15","25"].includes(String(state.installHeight)) ? String(state.installHeight) : "8";
    state.windClassification = ["N1","N2","N3","N4"].includes(String(state.windClassification).toUpperCase()) ? String(state.windClassification).toUpperCase() : "N3";
  }
  function framelessHeightLimit(){
    if (!isHeightLimitedFrameless()) return { valid:true };
    normaliseSiteState();
    const systemName = isPinFixedBalustrade() ? "15mm frameless pin-fixed" : isNovaFrameless() ? "12mm frameless Nova" : isMadridStandardFrameless() ? "12mm frameless Madrid Standard" : "15mm frameless Madrid Deluxe";
    if (isUnsure(state.installHeight)) {
      return { valid:false, message:`${systemName} is only available online when the fall protection height is confirmed under 5m. Please confirm the height or request a quote.` };
    }
    if ((Number(state.installHeight) || 0) > 5) {
      return { valid:false, message:`${systemName} is not compliant for fall protection heights of 5m or more in this online configurator. Please request a quote for higher installations.` };
    }
    return { valid:true };
  }
  function endLabel(type, sideIndex, end){
    if (type === "connected") {
      const next = end === "right" ? sideIndex + 1 : sideIndex - 1;
      return `Corner to Side ${String.fromCharCode(65+next)}`;
    }
    return type === "wall" ? "Wall" : "Open end";
  }

  function currentRule(){
    if (isPinFixedBalustrade()) {
      state.glass = "15";
      state.fixing = "pin_fixed";
      state.pinStandoffType = pinFixedBalustrade.standoffs[state.pinStandoffType] ? state.pinStandoffType : "fixed";
      state.pinStandoffDiameter = pinFixedBalustrade.standoffs[state.pinStandoffType][state.pinStandoffDiameter] ? state.pinStandoffDiameter : "50";
      state.pinStandoffDepth = pinFixedBalustrade.standoffs[state.pinStandoffType][state.pinStandoffDiameter][state.pinStandoffDepth] ? state.pinStandoffDepth : Object.keys(pinFixedBalustrade.standoffs[state.pinStandoffType][state.pinStandoffDiameter])[0];
      const finishOptions = pinFixedBalustrade.standoffs[state.pinStandoffType][state.pinStandoffDiameter][state.pinStandoffDepth];
      if (!finishOptions[state.finish]) state.finish = Object.keys(finishOptions)[0];
      state.pinHandrail = pinFixedBalustrade.handrails[state.pinHandrail] ? state.pinHandrail : "deluxe";
      if (state.pinHandrail === "deluxe" && ["black","white"].includes(state.finish)) state.pinHandrail = "series35";
      if (state.pinHandrail === "series35" && state.finish === "polished") state.finish = "satin";
      const handrail = pinFixedBalustrade.handrails[state.pinHandrail];
      const maxPanel = state.pinStandoffDiameter === "38" ? 750 : 1200;
      return {
        title:pinFixedBalustrade.title,
        glassTitle:pinFixedBalustrade.glassTitle,
        glassHeight:pinFixedBalustrade.glassHeight,
        glassPrefix:pinFixedBalustrade.glassPrefix,
        stock:pinFixedBalustrade.stock.filter(width => width <= maxPanel),
        maxPanel,
        spigotName:`${state.pinStandoffDiameter}mm ${state.pinStandoffType} standoffs`,
        handrail:handrail.handrail,
        handrailSku:handrail.handrailSku,
        rubberSku:handrail.rubberSku,
        gap:pinFixedBalustrade.gap,
        pinFixed:true,
        notes:[
          "Uses only 1280mm high 15mm heat-soaked pin-fixed stock panels.",
          `${state.pinStandoffDiameter}mm standoffs selected: max panel ${maxPanel}mm.`,
          "Standoff count comes from the selected panel hole counts.",
          ...handrail.notes
        ]
      };
    }
    if (isSemiBalustrade()) {
      state.semiGlass = semiBalustrade.glassFamilies[state.semiGlass] ? state.semiGlass : "12toughened";
      state.supportSystem = semiBalustrade.supportSystems[state.supportSystem] ? state.supportSystem : "two_edge_support";
      state.fixing = ["core","base"].includes(state.fixing) ? state.fixing : "base";
      state.handrailProfile = ["rectangular","oval"].includes(state.handrailProfile) ? state.handrailProfile : "rectangular";
      state.semiSiteFixing = semiBalustrade.spacingTables[state.semiSiteFixing] ? state.semiSiteFixing : "uncracked_concrete";
      normaliseSiteState();
      if (semiNeedsLaminatedGlass()) state.semiGlass = "1152laminated";
      if (!["black","white","monument"].includes(state.finish)) state.finish = "black";
      const glass = semiBalustrade.glassFamilies[state.semiGlass];
      const support = semiBalustrade.supportSystems[state.supportSystem];
      const profile = state.supportSystem === "offset_handrail" ? "offset" : state.handrailProfile;
      return {
        title:semiBalustrade.title,
        glassTitle:glass.title,
        glassHeight:glass.glassHeight,
        glassPrefix:glass.glassPrefix,
        stock:glass.stock,
        maxPanel:glass.maxPanel,
        spigotName:"50 x 50mm Australis posts",
        handrail:support.handrail,
        handrailSku:semiBalustrade.handrailSkus[profile],
        support,
        glassFamily:glass,
        rubberSku:semiBalustrade.accessorySkus.p41,
        gap:{ fixed:0 },
        notes:semiBalustrade.notes
      };
    }
    if (state.glass === "15") {
      state.spigot = "madridDeluxe";
      state.fixing = ["core","base"].includes(state.fixing) ? state.fixing : "core";
      if (!["polished","satin","black","white"].includes(state.finish)) state.finish = "polished";
      const rule = rules["15-madridDeluxe"];
      if (state.finish === "black" || state.finish === "white") {
        return {
          ...rule,
          handrail:"35mm Series Aluminium Handrail",
          handrailSku:"35MM-HANDRAIL",
          rubberSku:"(GO) SER35-RUB-15MM",
          notes:["15mm glass automatically uses Madrid Deluxe spigots.","Black and white 15mm layouts use the 35mm Series aluminium handrail because Deluxe Nanorail is not available in those finishes.","V1 uses stock glass up to 1400mm wide.","Layouts aim for gaps under 100mm where possible."]
        };
      }
      return rule;
    }
    if (state.spigot === "madridDeluxe" || !rules[`12-${state.spigot}`]) state.spigot = "nova";
    state.fixing = ["core","base"].includes(state.fixing) ? state.fixing : "core";
    return rules[`12-${state.spigot}`];
  }
  function handrailFamily(rule){
    if (rule.handrail.includes("35mm")) return "35";
    return state.glass === "15" ? "dlx" : "std";
  }
  function handrailPartSkus(rule){
    const family = handrailFamily(rule);
    if (family === "35") {
      if (rule.pinFixed) {
        return {
          rail:{
            satin:"(GO) SER35-R5800-SA",
            black:"(GO) SER35-R5800-B",
            white:"(GO) SER35-R5800-MW"
          },
          joiner:accessorySkus.joiner35,
          corner:accessorySkus.corner35,
          wall:{
            satin:"(GO) SER35-WBEXT-S",
            black:"(GO) SER35-WBEXT-B",
            white:"(GO) SER35-WBEXT-MW"
          },
          cap:accessorySkus.rail35Cap
        };
      }
      return {
        rail:accessorySkus.rail35,
        joiner:accessorySkus.joiner35,
        corner:accessorySkus.corner35,
        wall:accessorySkus.rail35Wall,
        cap:accessorySkus.rail35Cap
      };
    }
    if (family === "dlx") {
      return {
        rail:accessorySkus.railDlx,
        joiner:accessorySkus.joinerDlx,
        corner:accessorySkus.cornerDlx,
        wall:accessorySkus.dlxWall,
        cap:accessorySkus.dlxCap
      };
    }
    return {
      rail:accessorySkus.railStd,
      joiner:{
        polished:"(GO) STG-2521-J-P",
        satin:"(GO) STG-2521-J-S",
        black:"(GO) STG-2521-J-B",
        white:"(GO) STG-2521-J-MW"
      },
      corner:{
        polished:"(GO) STG-2521-90J-P",
        satin:"(GO) STG-2521-90J-S",
        black:"(GO) STG-2521-90J-B",
        white:"(GO) STG-2521-90J-MW"
      },
      wall:accessorySkus.stdWall,
      cap:accessorySkus.stdCap
    };
  }
  function finishSku(part, suffix){
    if (part && typeof part === "object") return part[state.finish] || part.default || "";
    return `${part}-${suffix}`;
  }
  function compatibleSpigots(){
    if (isSemiBalustrade() || isPinFixedBalustrade()) return [];
    return state.glass === "15"
      ? [{ id:"madridDeluxe", label:"Madrid Deluxe", sub:"Required for 15mm glass" }]
      : [{ id:"nova", label:"Nova", sub:"Premium minimal spigot" }, { id:"madrid", label:"Madrid Standard", sub:"12mm balustrade spigot" }];
  }
  function pinFixedHoleCount(width){
    return Number(width) >= 800 ? 6 : 4;
  }
  function pinFixedHoleLayout(width){
    const panelWidth = Number(width) || 0;
    const edge = panelWidth <= 600 ? 100 : 150;
    const columns = panelWidth >= 800
      ? [edge, panelWidth / 2, panelWidth - edge]
      : [edge, panelWidth - edge];
    return { columns, rowsFromBottom:[100,200] };
  }
  function getPinFixedStandoffCount(widths){
    return (widths || []).reduce((total, width) => total + pinFixedHoleCount(width), 0);
  }
  function pinFixedStandoffSku(){
    const options = pinFixedBalustrade.standoffs[state.pinStandoffType]?.[state.pinStandoffDiameter]?.[state.pinStandoffDepth];
    return options?.[state.finish] || "";
  }
  function pinFixedStandoffName(){
    const type = state.pinStandoffType === "adjustable" ? "Adjustable" : "Fixed";
    return `${type} ${state.pinStandoffDiameter}mm x ${state.pinStandoffDepth}mm standoff - ${finishes[state.finish].label}`;
  }
  function pinFixedSummaryHtml(layout){
    if (!layout?.valid) return "";
    const locationText = state.siteLocation === "indoor"
      ? "Indoor - external wind-region checks not applied"
      : "Outdoor - confirm Wind Region A/B and wind class suitability before ordering";
    return `<div><strong>Standoff set</strong><span>${pinFixedStandoffName()}</span></div><div><strong>Standoffs</strong><span>${layout.standoffCount} total from glass holes</span></div><div><strong>Location</strong><span>${locationText}</span></div><div><strong>PTS guard</strong><span>${state.pinStandoffDiameter}mm standoffs use max ${currentRule().maxPanel}mm stock panels; online option is under 5m only.</span></div>`;
  }
  function basePlateGlassClearance(){
    return state.spigot === "nova" ? 55 : 57;
  }
  function clampRun(persist=true){
    const value = Number(state.runLength);
    if (!Number.isFinite(value)) state.runLength = 6250;
    state.runLength = Math.min(30000, Math.max(600, Math.round(state.runLength/10)*10));
    if (persist) activeSide().runLength = state.runLength;
  }
  function withRunLength(length, fn, sideIndex=state.activeSide){
    const previous = state.runLength;
    const previousSide = state.activeSide;
    state.activeSide = sideIndex;
    state.runLength = Number(length) || previous;
    const result = fn();
    state.runLength = previous;
    state.activeSide = previousSide;
    return result;
  }
  function pickBalancedPanels(target, count, rule){
    const stock = rule.stock;
    const min = stock[0], max = Math.min(rule.maxPanel, stock[stock.length-1]);
    const widths = Array(count).fill(Math.max(min, Math.min(max, Math.round((target/count)/50)*50)));
    let diff = target - widths.reduce((a,b)=>a+b,0);
    let guard = 0;
    while (diff !== 0 && guard++ < 2000) {
      const step = diff > 0 ? 50 : -50;
      let moved = false;
      for (let i=0;i<widths.length && diff!==0;i++) {
        const next = widths[i] + step;
        if (next >= min && next <= max && stock.includes(next)) {
          widths[i] = next;
          diff -= step;
          moved = true;
        }
      }
      if (!moved) break;
    }
    return { widths, remainder:target - widths.reduce((a,b)=>a+b,0) };
  }
  function openEndOk(widths, rule){
    if (!rule.openEndMax) return true;
    if (effectiveEnd(state.activeSide, "left") === "open" && widths[0] > rule.openEndMax) return false;
    if (effectiveEnd(state.activeSide, "right") === "open" && widths[widths.length-1] > rule.openEndMax) return false;
    return true;
  }
  function endAdjustedWidths(widths, target, rule){
    if (!rule.openEndMax) return widths;
    const next = [...widths];
    if (effectiveEnd(state.activeSide, "left") === "open" && next[0] > rule.openEndMax) next[0] = 550;
    if (effectiveEnd(state.activeSide, "right") === "open" && next[next.length-1] > rule.openEndMax) next[next.length-1] = 550;
    let diff = target - next.reduce((a,b)=>a+b,0);
    let guard = 0;
    while (diff > 0 && guard++ < 1000) {
      let moved = false;
      for (let i=0;i<next.length && diff>0;i++) {
        if ((i===0 && effectiveEnd(state.activeSide, "left")==="open") || (i===next.length-1 && effectiveEnd(state.activeSide, "right")==="open")) continue;
        const candidate = next[i] + 50;
        if (candidate <= rule.maxPanel && rule.stock.includes(candidate)) {
          next[i] = candidate;
          diff -= 50;
          moved = true;
        }
      }
      if (!moved) break;
    }
    return next;
  }
  function semiEndRole(sideIndex, end){
    const type = effectiveEnd(sideIndex, end);
    if (type === "connected") return "corner90";
    return "oneWay";
  }
  function semiEndSetoutAllowance(sideIndex, end){
    const type = effectiveEnd(sideIndex, end);
    if (type === "connected") return 0;
    return type === "wall" ? 35 : 25;
  }
  function semiSetoutAllowance(sideIndex=state.activeSide){
    return semiEndSetoutAllowance(sideIndex, "left") + semiEndSetoutAllowance(sideIndex, "right");
  }
  function semiSetoutNote(sideIndex=state.activeSide){
    const ends = ["left","right"].map(end => effectiveEnd(sideIndex, end)).filter(type => type !== "connected");
    if (!ends.length) return "Connected ends use shared corner post setout";
    const hasWall = ends.includes("wall");
    const hasOpen = ends.includes("open");
    if (hasWall && hasOpen) return "Allows 35mm wall gap and 25mm open-end clearance";
    if (hasWall) return "Allows 35mm gap between wall and end post";
    return "Allows 25mm open-end clearance beyond end posts";
  }
  function semiLayoutRunLength(sideIndex=state.activeSide){
    return Math.max(1, (Number(state.runLength) || 0) - semiSetoutAllowance(sideIndex));
  }
  function semiPostCountForSide(){
    return Math.max(2, selectedLayout().count + 1);
  }
  function pickSemiBalustradePanels(target, count){
    const rule = currentRule();
    const stock = rule.stock;
    const min = stock[0], max = Math.min(rule.maxPanel, stock[stock.length-1]);
    const base = Math.max(min, Math.min(max, Math.round((target / count) / 50) * 50));
    const widths = Array(count).fill(base);
    let diff = target - widths.reduce((a,b)=>a+b,0);
    let guard = 0;
    while (diff !== 0 && guard++ < 4000) {
      const step = diff > 0 ? 50 : -50;
      let moved = false;
      for (let i=0;i<widths.length && diff!==0;i++) {
        const next = widths[i] + step;
        if (next >= min && next <= max && stock.includes(next)) {
          widths[i] = next;
          diff -= step;
          moved = true;
        }
      }
      if (!moved) break;
    }
    return { widths, remainder:target - widths.reduce((a,b)=>a+b,0) };
  }
  function semiPostRolesForCount(sideIndex, count){
    const postCount = count + 1;
    return Array.from({ length:postCount }, (_, index) => ({
      role:index === 0 ? semiEndRole(sideIndex, "left") : index === postCount - 1 ? semiEndRole(sideIndex, "right") : "twoWay",
      index
    }));
  }
  function semiInsertionRange(posts){
    let min = 0, max = 0;
    for (let i=0;i<posts.length-1;i++) {
      const leftRole = posts[i].role;
      const rightRole = posts[i+1].role;
      min += semiBalustrade.insert * 2;
      max += (semiBalustrade.maxInsert[leftRole] || semiBalustrade.insert) + (semiBalustrade.maxInsert[rightRole] || semiBalustrade.insert);
    }
    return { min, max };
  }
  function semiPtsPostSpacingLimit(){
    const siteFixing = semiBalustrade.spacingTables[state.semiSiteFixing] ? state.semiSiteFixing : "uncracked_concrete";
    const handrailCap = state.supportSystem === "offset_handrail" ? 1300 : Infinity;
    if (state.siteLocation === "indoor") {
      const rows = [];
      Object.entries(semiBalustrade.spacingTables[siteFixing] || {}).forEach(([regionKey, terrains]) => {
        Object.entries(terrains || {}).forEach(([terrainKey, row]) => {
          if (row) rows.push({ ...row, region:regionKey, terrain:terrainKey });
        });
      });
      const best = rows.sort((a,b)=>b.spacing-a.spacing || b.height-a.height)[0];
      if (!best) return { valid:false, message:"No indoor post-spacing row is available for the selected fixing method." };
      const spacing = Math.min(best.spacing, handrailCap);
      return {
        valid:true,
        spacing,
        rawSpacing:best.spacing,
        siteFixing,
        region:"Indoor",
        terrain:"Indoor",
        height:best.height,
        indoor:true,
        capped:spacing !== best.spacing
      };
    }
    const region = isUnsure(state.windRegion) ? "unsure" : String(state.windRegion || "A").toUpperCase();
    const windClass = String(state.windClassification || "N3").toUpperCase();
    if (!isUnsure(region) && !["A","B"].includes(region)) {
      return { valid:false, message:"This semi-frameless balustrade system is not compliant for the selected wind region. The Australis PTS covers Wind Regions A and B only." };
    }
    if (!["N1","N2","N3"].includes(windClass)) {
      return { valid:false, message:"This semi-frameless balustrade system is not compliant for the selected wind classification. The Australis PTS covers wind classifications up to N3 only." };
    }
    const terrain = isUnsure(state.terrainCategory) ? "unsure" : String(state.terrainCategory || "2");
    const selectedHeight = isUnsure(state.installHeight) ? Infinity : Number(state.installHeight) || 8;
    const conservative = isUnsure(region) || isUnsure(terrain) || isUnsure(state.installHeight);
    if (conservative) {
      let best = null;
      const regions = isUnsure(region) ? ["A","B"] : [region];
      const terrains = isUnsure(terrain) ? ["1","2","3"] : [terrain];
      regions.forEach(candidateRegion => {
        terrains.forEach(candidateTerrain => {
          const candidate = semiBalustrade.spacingTables[siteFixing]?.[candidateRegion]?.[candidateTerrain];
          if (!candidate) return;
          if (!isUnsure(state.installHeight) && selectedHeight > candidate.height) return;
          const spacing = Math.min(candidate.spacing, handrailCap);
          if (!best || spacing < best.spacing) best = { ...candidate, spacing, rawSpacing:candidate.spacing, region:candidateRegion, terrain:candidateTerrain };
        });
      });
      if (!best) return { valid:false, message:"No conservative PTS post-spacing row matches the selected wind/site settings." };
      return {
        valid:true,
        spacing:best.spacing,
        rawSpacing:best.rawSpacing,
        siteFixing,
        region:best.region,
        terrain:best.terrain,
        height:best.height,
        conservative:true,
        capped:best.spacing !== best.rawSpacing
      };
    }
    const row = semiBalustrade.spacingTables[siteFixing]?.[region]?.[terrain];
    if (!row) return { valid:false, message:"No PTS post-spacing row matches the selected wind/site settings." };
    if (selectedHeight > row.height) {
      return { valid:false, message:`Selected installation height ${semiBalustrade.installHeights[String(selectedHeight)] || `${selectedHeight}m`} exceeds the PTS limit for this wind/site row.` };
    }
    const spacing = Math.min(row.spacing, handrailCap);
    return {
      valid:true,
      spacing,
      rawSpacing:row.spacing,
      siteFixing,
      region,
      terrain,
      height:row.height,
      capped:spacing !== row.spacing
    };
  }
  function pickSemiBalustradePanelsInRange(minTarget, maxTarget, count){
    const rule = currentRule();
    const minStockTotal = count * rule.stock[0];
    const maxStockTotal = count * rule.maxPanel;
    const first = Math.max(minStockTotal, Math.ceil(minTarget / 50) * 50);
    const last = Math.min(maxStockTotal, Math.floor(maxTarget / 50) * 50);
    let best = null;
    for (let target = last; target >= first; target -= 50) {
      const candidate = pickSemiBalustradePanels(target, count);
      if (Math.abs(candidate.remainder) > 0) continue;
      const variation = Math.max(...candidate.widths) - Math.min(...candidate.widths);
      const tiny = candidate.widths.filter(w => w <= 450).length;
      const score = target - variation * 2 - tiny * 300;
      if (!best || score > best.score) best = { ...candidate, target, score };
    }
    return best || { widths:[], remainder:Infinity, target:0, score:-Infinity };
  }
  function distributeSemiPanelInserts(widths, posts, requiredInsertion){
    const pockets = [];
    const panelInserts = widths.map(() => ({ left:semiBalustrade.insert, right:semiBalustrade.insert }));
    let total = widths.length * semiBalustrade.insert * 2;
    widths.forEach((width, index) => {
      const leftCap = semiBalustrade.maxInsert[posts[index]?.role] || semiBalustrade.insert;
      const rightCap = semiBalustrade.maxInsert[posts[index+1]?.role] || semiBalustrade.insert;
      pockets.push({ panel:index, side:"left", capacity:Math.max(0, leftCap - semiBalustrade.insert), width });
      pockets.push({ panel:index, side:"right", capacity:Math.max(0, rightCap - semiBalustrade.insert), width });
    });
    let remaining = requiredInsertion - total;
    if (remaining < -0.01) return null;
    pockets.sort((a,b)=>b.width-a.width || b.capacity-a.capacity);
    for (const pocket of pockets) {
      if (remaining <= 0.01) break;
      const add = Math.min(pocket.capacity, remaining);
      panelInserts[pocket.panel][pocket.side] += add;
      total += add;
      remaining -= add;
    }
    if (Math.abs(requiredInsertion - total) > 0.01) return null;
    return panelInserts;
  }
  function generateSemiBalustradeLayouts(){
    clampRun(false);
    const rule = currentRule();
    const pts = semiPtsPostSpacingLimit();
    if (!pts.valid) return [{ id:"semi-review", valid:false, label:"Manual review", message:pts.message }];
    const layoutRunLength = semiLayoutRunLength(state.activeSide);
    const setoutAllowance = semiSetoutAllowance(state.activeSide);
    const results = [];
    const maxCount = Math.ceil(layoutRunLength / 300) + 2;
    for (let count=1; count<=maxCount; count++) {
      const postCount = count + 1;
      const posts = semiPostRolesForCount(state.activeSide, count);
      const insertRange = semiInsertionRange(posts);
      const minPanelTarget = layoutRunLength - postCount * semiBalustrade.postWidth + insertRange.min;
      const maxPanelTarget = layoutRunLength - postCount * semiBalustrade.postWidth + insertRange.max;
      if (maxPanelTarget < count * rule.stock[0] || minPanelTarget > count * rule.maxPanel) continue;
      const { widths, remainder, target } = pickSemiBalustradePanelsInRange(minPanelTarget, maxPanelTarget, count);
      if (Math.abs(remainder) > 0) continue;
      const variation = Math.max(...widths) - Math.min(...widths);
      const tiny = widths.filter(w => w <= 450).length;
      const requiredInsertion = target + postCount * semiBalustrade.postWidth - layoutRunLength;
      const panelInserts = distributeSemiPanelInserts(widths, posts, requiredInsertion);
      if (!panelInserts) continue;
      const pocketCount = count * 2;
      const averageInsert = requiredInsertion / pocketCount;
      const maxPostSpacing = Math.max(...widths.map((width, index) => semiBalustrade.postWidth + width - panelInserts[index].left - panelInserts[index].right));
      if (maxPostSpacing > pts.spacing + 0.01) continue;
      const physicalGlassSpan = widths.reduce((sum,w)=>sum+w,0) - requiredInsertion;
      const setout = postCount * semiBalustrade.postWidth + physicalGlassSpan;
      if (Math.abs(setout - layoutRunLength) > 0.01) continue;
      results.push({
        id:`semi-layout-${results.length+1}`,
        system:semiBalustrade.systemId,
        count,
        widths,
        gap:0,
        insert:averageInsert,
        panelInserts,
        insertRange,
        maxPostSpacing,
        setoutAllowance,
        layoutRunLength,
        pts,
        postWidth:semiBalustrade.postWidth,
        posts,
        score:10000 - count*900 - variation/5 - tiny*80 + target/100,
        valid:true,
        label:"Recommended",
        why:[
          `Uses ${rule.glassHeight}mm ${state.semiGlass === "1152laminated" ? "toughened laminated " : "toughened heat-soaked "}stock balustrade glass panels`,
          `Uses individual pocket inserts from ${semiBalustrade.insert}mm to each post's maximum depth`,
          semiSetoutNote(state.activeSide),
          `Keeps post spacing at ${Math.round(maxPostSpacing)}mm, within the ${pts.spacing}mm PTS limit`,
          "Counts rubber from glazed post pockets"
        ]
      });
    }
    results.sort((a,b)=>b.score-a.score);
    if (!results.length) return [{ id:"semi-review", valid:false, label:"Manual review", message:"No stock-panel semi-frameless balustrade layout fits this run with 50mm posts and 15mm glass insertion." }];
    const lowest = [...results].sort((a,b)=>a.count-b.count || b.score-a.score)[0];
    const appearance = [...results].sort((a,b)=>(Math.max(...a.widths)-Math.min(...a.widths))-(Math.max(...b.widths)-Math.min(...b.widths)) || a.count-b.count)[0];
    const unique = [];
    [{...lowest,label:"Best value"},{...appearance,label:"Best appearance"},{...lowest,label:"Lowest product count"}].forEach(item => {
      const key = `${item.widths.join("-")}|${item.posts.map(p=>p.role).join("-")}`;
      if (!unique.some(u => `${u.widths.join("-")}|${u.posts.map(p=>p.role).join("-")}` === key)) unique.push(item);
    });
    return unique;
  }
function generateLayouts(){
  clampRun(false);
  if (isSemiBalustrade()) return generateSemiBalustradeLayouts();
  const heightLimit = framelessHeightLimit();
  if (!heightLimit.valid) return [{ id:"frameless-height-review", valid:false, label:"Manual review", message:heightLimit.message }];
  const rule = currentRule();
  const results = [];
  const maxCount = Math.ceil(state.runLength / 300) + 2;
  const endGapCount =
    (endNeedsGapForSide(state.activeSide, "left") ? 1 : 0) +
    (endNeedsGapForSide(state.activeSide, "right") ? 1 : 0);
  for (let count=1; count<=maxCount; count++) {
    const candidateTargets = [];
    const gapCount = Math.max(0, count - 1 + endGapCount);
    if (rule.gap.fixed !== undefined) {
      candidateTargets.push({
        panelTarget: state.runLength - rule.gap.fixed * gapCount,
        gap: rule.gap.fixed
      });
    } else if (gapCount === 0) {
      candidateTargets.push({ panelTarget: state.runLength, gap:0 });
    } else {
      const minStock = rule.stock[0] || 300;
      const minTarget = Math.max(minStock * count, state.runLength - rule.gap.max * gapCount);
      const maxTarget = Math.min(rule.maxPanel * count, state.runLength - rule.gap.min * gapCount);
      for (let target=Math.ceil(minTarget/50)*50; target<=maxTarget; target+=50) {
        const gap = (state.runLength - target) / gapCount;
        if (gap >= rule.gap.min && gap <= rule.gap.max) candidateTargets.push({ panelTarget:target, gap });
      }
    }
      candidateTargets.forEach(candidate => {
        let { widths, remainder } = pickBalancedPanels(candidate.panelTarget, count, rule);
        widths = endAdjustedWidths(widths, candidate.panelTarget, rule);
        remainder = candidate.panelTarget - widths.reduce((a,b)=>a+b,0);
        if (Math.abs(remainder) > 0) return;
        if (!openEndOk(widths, rule)) return;
        const variation = Math.max(...widths) - Math.min(...widths);
        const tiny = widths.filter(w => w <= 450).length;
        const gap = candidate.gap;
        const score = 1000 - count*16 - variation/5 - tiny*40 - Math.abs(gap-(rule.gap.fixed ?? rule.gap.preferred ?? 70));
        const pinFixed = isPinFixedBalustrade();
        results.push({
          id:`layout-${results.length+1}`,
          count,
          widths,
          gap:Number(gap.toFixed(1)),
          standoffCount:pinFixed ? getPinFixedStandoffCount(widths) : 0,
          score,
          valid:true,
          label:"Recommended",
          why:pinFixed
            ? [
              `Uses 1280mm high 15mm heat-soaked stock panels up to ${rule.maxPanel}mm`,
              `${getPinFixedStandoffCount(widths)} standoffs counted from the selected glass hole pattern`,
              `Includes ${rule.handrail}`
            ]
            : ["Uses standard stock glass panels","Keeps panel widths visually balanced","Includes the required handrail system"]
        });
      });
    }
    results.sort((a,b)=>b.score-a.score);
    if (!results.length) return [{ id:"review", valid:false, label:"Manual review", message:"No stock-panel layout fits the selected rules. Please request a quote." }];
    const lowest = [...results].sort((a,b)=>a.count-b.count || b.score-a.score)[0];
    const recommended = {
      ...lowest,
      label:"Best value",
      why:isPinFixedBalustrade()
        ? [
          `Uses the fewest practical 1280mm pin-fixed stock panels`,
          `${lowest.standoffCount} standoffs counted from the final panel hole counts`,
          "Keeps gaps within the selected system rules"
        ]
        : ["Uses the fewest practical stock glass panels","Keeps gaps within the selected system rules","Includes the required handrail system"]
    };
    const appearance = [...results].sort((a,b)=>(Math.max(...a.widths)-Math.min(...a.widths))-(Math.max(...b.widths)-Math.min(...b.widths)) || a.count-b.count)[0];
    const unique = [];
    [recommended,{...appearance,label:"Best appearance"},{...lowest,label:"Lowest product count"}].forEach(item => {
      const key = item.valid ? `${item.widths.join("-")}|${item.gap}` : item.id;
      if (!unique.some(u => (u.valid ? `${u.widths.join("-")}|${u.gap}` : u.id) === key)) unique.push(item);
    });
    return unique;
  }
  function selectedLayout(){
    const layouts = generateLayouts();
    const selected = layouts.find(l => l.label.toLowerCase().replace(/\s+/g,"") === state.layoutMode.toLowerCase());
    return selected || layouts[0];
  }
  function addLine(lines, sku, name, qty, note="", unit="each"){
    if (!sku || !qty) return;
    const existing = lines.find(l => l.sku === sku && (l.unit || "each") === unit);
    if (existing) {
      existing.qty += qty;
      if (note && existing.note && !existing.note.includes(note)) existing.note += `; ${note}`;
      else if (note && !existing.note) existing.note = note;
    } else {
      lines.push({ sku, name, qty, note, unit });
    }
  }
  function handrailPlan(layout, rule){
    const stockLength = 5800;
    const railCount = Math.ceil(state.runLength / stockLength);
    const pieces = [];
    let remaining = state.runLength;
    for (let i=1;i<=railCount;i++) {
      const use = Math.min(stockLength, remaining);
      pieces.push({ rail:i, stock:stockLength, use });
      remaining -= use;
    }
    return { pieces, joiners:Math.max(0, railCount-1) };
  }
  function projectRunLength(){
    return state.sides.slice(0,state.sideCount).reduce((total, side) => total + (Number(side.runLength) || 0), 0);
  }
  function rubberStockLength(rule){
    if (rule.rubberSku && rule.rubberSku.indexOf("SER35") >= 0) return 6000;
    return 2900;
  }
  function projectHandrailPlan(rule){
    const stockLength = 5800;
    const totalLength = projectRunLength();
    const railCount = Math.max(1, Math.ceil(totalLength / stockLength));
    const cornerJoiners = Math.max(0, state.sideCount - 1);
    const inlineJoiners = state.sides.slice(0,state.sideCount).reduce((total, side) => {
      const sideRails = Math.max(1, Math.ceil((Number(side.runLength) || 0) / stockLength));
      return total + Math.max(0, sideRails - 1);
    }, 0);
    const rubberLength = rubberStockLength(rule);
    const rubberCount = Math.max(1, Math.ceil(totalLength / rubberLength));
    const pieces = [];
    let remaining = totalLength;
    for (let i=1;i<=railCount;i++) {
      const use = Math.min(stockLength, remaining);
      pieces.push({ rail:i, stock:stockLength, use });
      remaining -= use;
    }
    return { pieces, railCount, totalLength, inlineJoiners, cornerJoiners, rubberLength, rubberCount };
  }
  function addProjectHandrailLines(lines, rule){
    const rail = projectHandrailPlan(rule);
    const finishSuffix = skuFinish();
    const handrailSkus = handrailPartSkus(rule);
    addLine(lines, finishSku(handrailSkus.rail, finishSuffix), `${rule.handrail} 5800mm rail - ${finishes[state.finish].label}`, rail.railCount, `Supplied in stock lengths for ${fmt(rail.totalLength)} total handrail`);
    if (!(rule.pinFixed && rule.handrailSku === "35MM-HANDRAIL")) {
      addLine(lines, `${rule.rubberSku}`, `${rule.handrail} glazing rubber`, rail.rubberCount, `${rail.rubberLength}mm lengths for handrail glazing`);
    }
    if (rail.inlineJoiners) addLine(lines, finishSku(handrailSkus.joiner, finishSuffix), `${rule.handrail} inline joiner - ${finishes[state.finish].label}`, rail.inlineJoiners, "Required where straight rail lengths join");
    if (rail.cornerJoiners) addLine(lines, finishSku(handrailSkus.corner, finishSuffix), `${rule.handrail} 90 degree corner joiner - ${finishes[state.finish].label}`, rail.cornerJoiners, "Required where balustrade sides turn a corner");
    const wallSku = finishSku(handrailSkus.wall, finishSuffix);
    const capSku = finishSku(handrailSkus.cap, finishSuffix);
    const startType = effectiveEnd(0, "left");
    const finalType = effectiveEnd(state.sideCount - 1, "right");
    if (startType === "wall") addLine(lines, wallSku, `${rule.handrail} wall fitting - start of Side A`, 1);
    if (startType === "open" && !(rule.pinFixed && rule.handrailSku === "35MM-HANDRAIL")) addLine(lines, capSku, `${rule.handrail} end cap - start of Side A`, 1);
    if (finalType === "wall") addLine(lines, wallSku, `${rule.handrail} wall fitting - final end`, 1);
    if (finalType === "open" && !(rule.pinFixed && rule.handrailSku === "35MM-HANDRAIL")) addLine(lines, capSku, `${rule.handrail} end cap - final end`, 1);
  }
  function semiProjectPostCounts(){
    const counts = { oneWay:0, twoWay:0, corner90:Math.max(0, state.sideCount - 1) };
    const startType = effectiveEnd(0, "left");
    const finalType = effectiveEnd(state.sideCount - 1, "right");
    if (startType === "wall" || startType === "open") counts.oneWay += 1;
    if (finalType === "wall" || finalType === "open") counts.oneWay += 1;
    state.sides.slice(0,state.sideCount).forEach((side, index) => {
      const layout = withRunLength(side.runLength, () => selectedLayout(), index);
      if (layout?.valid) counts.twoWay += Math.max(0, layout.count - 1);
    });
    return counts;
  }
  function semiPostLabel(role){
    if (role === "corner90") return "90-degree";
    if (role === "twoWay") return "two-way";
    return "one-way";
  }
  function semiPostBomLine(role, qty, postSet, suffix, fixingLabel, finishLabel){
    if (state.fixing === "core" && suffix === "MN") {
      const sku = role === "corner90" ? "A50-5800-90-MN" : `A50-5800D-${role === "oneWay" ? "1W" : "2W"}-MN`;
      const lengths = Math.max(1, Math.ceil(qty / 4));
      return {
        sku,
        qty:lengths,
        name:`50 x 50mm 5800mm core-drill ${semiPostLabel(role)} semi-frameless balustrade post extrusion - ${finishLabel}`,
        note:`Cut to make ${qty} x 1400mm ${semiPostLabel(role)} post${qty === 1 ? "" : "s"}.`
      };
    }
    return {
      sku:`${postSet[role]}-${suffix}`,
      qty,
      name:`50 x 50mm ${fixingLabel} ${semiPostLabel(role)} semi-frameless balustrade post - ${finishLabel}`,
      note:"Variant ID and bundled component status need Shopify mapping review."
    };
  }
  function addSemiHandrailLines(lines, postTotal, counts){
    const data = semiBalustrade;
    const support = data.supportSystems[state.supportSystem];
    const suffix = finishes[state.finish].suffix;
    const finishLabel = finishes[state.finish].label;
    const totalLength = projectRunLength();
    const railCount = Math.max(1, Math.ceil(totalLength / 5800));
    const startType = effectiveEnd(0, "left");
    const finalType = effectiveEnd(state.sideCount - 1, "right");
    const wallEnds = (startType === "wall" ? 1 : 0) + (finalType === "wall" ? 1 : 0);
    const topScrewSku = state.finish === "black" || state.finish === "monument" ? "AR-SCR-BR-50PK-B" : state.finish === "white" ? "AR-SCR-BR-50PK-W" : "AR-SCR-BR-50PK";
    const offsetHandrailScrewSku = state.finish === "black" || state.finish === "monument" ? "VIS-SCR-CSK-50PK-B" : state.finish === "white" ? "VIS-SCR-CSK-50PK-W" : "VIS-SCR-CSK-50PK";
    const openEnds = (startType === "open" ? 1 : 0) + (finalType === "open" ? 1 : 0);
    if (state.supportSystem === "offset_handrail") {
      const offsetBracketSku = suffix === "M" ? "A50-OFF-RC-SWIV-M" : `${data.handrailAccessorySkus.offsetBracket}-${suffix}`;
      addLine(lines, `${data.handrailSkus.offset}-${suffix}`, `${support.handrail} 5800mm - ${finishLabel}`, railCount, `Supplied for ${fmt(totalLength)} total handrail.`);
      addLine(lines, offsetBracketSku, `Offset handrail bracket - ${finishLabel}`, postTotal, "One bracket at every post support.");
      if (counts.corner90) addLine(lines, `${data.handrailAccessorySkus.offsetCornerBracket}-${suffix}`, `90-degree offset handrail bracket - ${finishLabel}`, counts.corner90, "Required at 90-degree corner posts.");
      if (railCount > 1) addLine(lines, data.handrailAccessorySkus.offsetJoiner, "Offset handrail inline joiner", railCount - 1, "Required where straight handrail lengths join.");
      if (counts.corner90) addLine(lines, data.handrailAccessorySkus.offsetCornerJoiner, "Offset handrail 90-degree joiner", counts.corner90, "Required where offset handrail turns 90 degrees.");
      if (openEnds) addLine(lines, `${data.handrailAccessorySkus.offsetEnd}-${suffix}`, `Offset handrail end cap - ${finishLabel}`, openEnds, "Exposed handrail terminations only.");
      if (wallEnds) addLine(lines, `${data.handrailAccessorySkus.offsetWall}-${suffix}`, `Offset handrail wall bracket - ${finishLabel}`, wallEnds, "Wall handrail terminations only.");
      addLine(lines, data.handrailAccessorySkus.offsetBracketScrew, "8g x 15mm pan-head bracket screw pack", Math.max(1, Math.ceil(postTotal / 25)), "For brackets to posts.");
      addLine(lines, offsetHandrailScrewSku, "8g x 25mm countersunk handrail screw pack", Math.max(1, Math.ceil(postTotal / 25)), "For offset handrail to brackets; visible finish may need review.");
      return;
    }
    const profileKey = state.handrailProfile === "oval" ? "oval" : "rectangular";
    const profileLabel = profileKey === "oval" ? "Oval" : "Rectangular";
    addLine(lines, `${data.handrailSkus[profileKey]}-${suffix}`, `${profileLabel} ${support.handrail} 5800mm - ${finishLabel}`, railCount, `Two-part undercapping and snap-on handrail for ${fmt(totalLength)} total handrail.`);
    if (railCount > 1) addLine(lines, topScrewSku, "12g x 25mm handrail-to-post screw pack", Math.max(1, Math.ceil(postTotal / 25)), "For mechanical fixing of top handrail to posts.");
    else addLine(lines, topScrewSku, "12g x 25mm handrail-to-post screw pack", 1, "For mechanical fixing of top handrail to posts.");
    if (openEnds) {
      const endBase = profileKey === "oval" ? data.handrailAccessorySkus.ovalEnd : data.handrailAccessorySkus.rectangularEnd;
      addLine(lines, `${endBase}-${suffix}`, `${profileLabel} handrail end cap - ${finishLabel}`, openEnds, "Exposed handrail terminations only.");
    }
    if (wallEnds) addLine(lines, `${data.handrailAccessorySkus.wall}-${suffix}`, `Handrail wall plate - ${finishLabel}`, wallEnds, "Wall handrail terminations only.");
  }
  function addSemiBalustradeHardwareLines(lines){
    const counts = semiProjectPostCounts();
    const finishLabel = finishes[state.finish].label;
    const suffix = finishes[state.finish].suffix;
    const data = semiBalustrade;
    const fixingLabel = state.fixing === "core" ? "core-drill" : "welded base-plated";
    const postSet = data.postSkus[state.fixing];
    [
      ["oneWay", counts.oneWay],
      ["twoWay", counts.twoWay],
      ["corner90", counts.corner90]
    ].forEach(([role, qty]) => {
      if (!qty) return;
      const postLine = semiPostBomLine(role, qty, postSet, suffix, fixingLabel, finishLabel);
      addLine(lines, postLine.sku, postLine.name, postLine.qty, postLine.note);
    });
    const pocketCount = counts.oneWay + counts.twoWay * 2 + counts.corner90 * 2;
    const topEdgeCount = data.supportSystems[state.supportSystem].topRubber
      ? activeProjectLayouts().reduce((total, layout) => total + (layout?.valid ? layout.count : 0), 0)
      : 0;
    const rubberLengths = pocketCount + topEdgeCount;
    const rubberPacks = Math.max(1, Math.ceil(rubberLengths / 10));
    addLine(lines, data.accessorySkus.p41, "P41/22 glazing rubber 10 pack", rubberPacks, `${pocketCount} vertical post pockets${topEdgeCount ? ` plus ${topEdgeCount} top handrail glass edges` : ""} counted.`);
    addLine(lines, data.accessorySkus.captive, "Yellow captive glazing rubber 10 pack", rubberPacks, `${pocketCount} vertical post pockets${topEdgeCount ? ` plus ${topEdgeCount} top handrail glass edges` : ""} counted.`);
    const underGlassInfillMm = 50;
    const infillStockLength = 1400;
    const infillTotalMm = pocketCount * underGlassInfillMm;
    const infillLengths = Math.max(1, Math.ceil(infillTotalMm / infillStockLength));
    addLine(lines, `${data.accessorySkus.infill}-${suffix}`, "Post infill extrusion 1400mm length", infillLengths, `${pocketCount} post pockets need approx ${underGlassInfillMm}mm under-glass infill for sitting blocks; ${fmt(infillTotalMm)} total, rounded up to ${infillLengths} stock length${infillLengths === 1 ? "" : "s"}. Full-height infill is not allowed by default unless a gate/closing side detail is confirmed.`);
    addLine(lines, data.accessorySkus.sittingBlock, "Sitting block packs", Math.max(1, Math.ceil(pocketCount / 20)), "Sitting block packs for semi-frameless glass panels. Sit on top of infill.");
    const postTotal = counts.oneWay + counts.twoWay + counts.corner90;
    if (state.fixing === "core") {
      addLine(lines, `${data.coverSkus.coreDress}-${suffix}`, `50 x 50mm dress ring - ${finishLabel}`, postTotal, "Dress rings for core-drill semi-frameless balustrade posts.");
    } else {
      addLine(lines, `${data.coverSkus.baseDome}-${suffix}`, `Semi-frameless post domical cover - ${finishLabel}`, postTotal, "Use one compatible domical cover per welded base-plated post.");
    }
    if (state.supportSystem === "two_edge_support") {
      addLine(lines, `${data.capSkus.notchedOneWay}-${suffix}`, `One-way notched top plate - ${finishLabel}`, counts.oneWay, "2-edge support post-top treatment.");
      addLine(lines, `${data.capSkus.notchedTwoWay}-${suffix}`, `Two-way notched top plate - ${finishLabel}`, counts.twoWay, "2-edge support post-top treatment.");
      addLine(lines, `${data.capSkus.notchedCorner90}-${suffix}`, `90-degree notched top plate - ${finishLabel}`, counts.corner90, "2-edge support post-top treatment.");
    }
    if (state.supportSystem === "offset_handrail") {
      addLine(lines, `${data.capSkus.flat}-${suffix}`, `50 x 50mm flat top plate - ${finishLabel}`, postTotal, "Offset handrail uses flat post caps.");
    }
    addSemiHandrailLines(lines, postTotal, counts);
  }
  function generateBOM(layout=selectedLayout(), includeHandrail=true){
    const rule = currentRule();
    const lines = [];
    if (!layout.valid) return lines;
    if (isSemiBalustrade()) {
      layout.widths.forEach(width => addLine(lines, `${rule.glassPrefix}-${pad4(width)}`, `${rule.glassHeight}mm high ${rule.glassFamily.thickness} semi-frameless balustrade glass panel ${width}mm`, 1, `Stock ${rule.glassHeight}mm balustrade glass`));
      return lines;
    }
    if (isPinFixedBalustrade()) {
      layout.widths.forEach(width => addLine(lines, `${rule.glassPrefix}-${pad4(width)}`, `${rule.glassHeight}mm high 15mm heat-soaked pin-fixed balustrade glass panel ${width}mm`, 1, `${pinFixedHoleCount(width)} standoff holes`));
      addLine(lines, pinFixedStandoffSku(), pinFixedStandoffName(), layout.standoffCount, "Standoff quantity comes from the selected glass panel hole counts.");
      if (includeHandrail) addProjectHandrailLines(lines, rule);
      return lines;
    }
    layout.widths.forEach(width => addLine(lines, `${rule.glassPrefix}-${pad4(width)}`, `${rule.glassHeight}mm high ${state.glass}mm heat-soaked glass panel ${width}mm`, 1, "Stock rectangular glass"));
    const spigotQty = layout.widths.length * 2;
    const finishSuffix = skuFinish();
    const spigotSkuSource = spigotSkus[state.spigot][state.fixing];
    const spigotSku = typeof spigotSkuSource === "string" ? `${spigotSkuSource}-${finishSuffix}` : spigotSkuSource[state.finish];
    const novaBundleLabel = state.spigot === "nova"
      ? (state.fixing === "core" ? " with dress ring" : " with domical cover")
      : "";
    addLine(lines, spigotSku, `${rule.spigotName} ${state.fixing === "core" ? "core drill" : "base plate"} spigot${novaBundleLabel} - ${finishes[state.finish].label}`, spigotQty, "2 spigots per glass panel");
    if (includeHandrail) addProjectHandrailLines(lines, rule);
    return lines;
  }
  function generateProjectBOM(){
    const combined = [];
    state.sides.slice(0,state.sideCount).forEach((side, index) => {
      const sideLines = withRunLength(side.runLength, () => generateBOM(selectedLayout(), false), index);
      sideLines.forEach(line => addLine(combined, line.sku, line.name, line.qty, line.note ? `Side ${String.fromCharCode(65+index)} &bull; ${line.note}` : `Side ${String.fromCharCode(65+index)}`));
    });
    if (combined.length) addProjectHandrailLines(combined, currentRule());
    return combined;
  }
  function activeProjectLayouts(){
    return state.sides.slice(0,state.sideCount).map((side,index) =>
      withRunLength(side.runLength, () => selectedLayout(), index)
    );
  }
  function projectGlassAreaM2(){
    const rule = currentRule();
    return activeProjectLayouts().reduce((total, layout) => {
      if (!layout?.valid) return total;
      return total + layout.widths.reduce((sum, width) => sum + (width * rule.glassHeight) / 1000000, 0);
    }, 0);
  }
  function factoryEnduroShieldLine(){
    const bothSidesArea = projectGlassAreaM2() * 2;
    const qty = Math.max(1, Math.ceil(bothSidesArea));
    return {
      sku:"FACTORY-ENDUROSHIELD",
      name:"Factory applied EnduroShield glass coating",
      qty,
      unit:"m2",
      note:`Both sides of balustrade glass. ${bothSidesArea.toFixed(1)}m2 measured, rounded to ${qty}m2 charged x $65/m2.`
    };
  }
  function groutSikaLine(){
    const spigotQty = activeProjectLayouts().reduce((total, layout) => total + (layout?.valid ? layout.widths.length * 2 : 0), 0);
    const qty = Math.max(1, Math.ceil(spigotQty / 30));
    return {
      sku:"GROUT-SIKA",
      name:"Sika grout",
      qty,
      note:`Optional grout for core-drilled balustrade spigots. Estimated from ${spigotQty} spigots.`
    };
  }
  function chemsetLine(){
    const spigotQty = activeProjectLayouts().reduce((total, layout) => total + (layout?.valid ? layout.widths.length * 2 : 0), 0);
    const qty = Math.max(1, Math.ceil(spigotQty / 30));
    return {
      sku:"SOUD-CA1400",
      name:"Soudal chemset",
      qty,
      note:`Optional chemset for base-plated balustrade spigot fixing. Estimated from ${spigotQty} spigots.`
    };
  }
  function concreteFixingLine(){
    const spigotQty = activeProjectLayouts().reduce((total, layout) => total + (layout?.valid ? layout.widths.length * 2 : 0), 0);
    const qty = Math.max(1, Math.ceil(spigotQty / 4));
    return {
      sku:"S-120ROD-4PK",
      name:"Concrete fixing kit",
      qty,
      note:`Optional concrete fixing kit for base-plated balustrade spigots. Estimated from ${spigotQty} spigots.`
    };
  }
  function semiProjectPostTotal(){
    const counts = semiProjectPostCounts();
    return counts.oneWay + counts.twoWay + counts.corner90;
  }
  function semiGroutSikaLine(){
    const postTotal = semiProjectPostTotal();
    const qty = Math.max(1, Math.ceil(postTotal / 30));
    return {
      sku:"GROUT-SIKA",
      name:"Sika grout",
      qty,
      note:`Optional grout for core-drilled semi-frameless balustrade posts. Estimated from ${postTotal} posts.`
    };
  }
  function semiChemsetLine(){
    const postTotal = semiProjectPostTotal();
    const qty = Math.max(1, Math.ceil(postTotal / 30));
    return {
      sku:"SOUD-CA1400",
      name:"Soudal chemset",
      qty,
      note:`Optional chemset for base-plated semi-frameless balustrade post fixing. Estimated from ${postTotal} posts.`
    };
  }
  function semiConcreteFixingLine(){
    const postTotal = semiProjectPostTotal();
    const qty = Math.max(1, postTotal);
    return {
      sku:"S-120ROD-4PK",
      name:"Concrete fixing kit",
      qty,
      note:`Optional extra concrete fixing kit for base-plated semi-frameless balustrade posts. One kit has 4 bolts for one post. Estimated from ${postTotal} posts.`
    };
  }
  function pinFixedStandoffTotal(){
    return activeProjectLayouts().reduce((total, layout) => total + (layout?.valid ? layout.standoffCount || 0 : 0), 0);
  }
  function pinFixedSikaLine(){
    const standoffs = pinFixedStandoffTotal();
    const qty = Math.max(1, Math.ceil(standoffs / 30));
    return {
      sku:"GROUT-SIKA",
      name:"Sika grout",
      qty,
      note:`Optional grout/adhesive allowance for pin-fixed balustrade standoff fixings. Estimated from ${standoffs} standoffs.`
    };
  }
  function pinFixedConcreteFixingLine(){
    const standoffs = pinFixedStandoffTotal();
    const qty = Math.max(1, Math.ceil(standoffs / 4));
    return {
      sku:"S-120ROD-4PK",
      name:"Concrete fixing kit",
      qty,
      note:`Optional concrete fixing kit for pin-fixed balustrade standoffs. Estimated from ${standoffs} standoffs.`
    };
  }
  function pinFixedExtraQty(extra, standoffs){
    if (extra.unit === "m2") return factoryEnduroShieldLine().qty;
    if (extra.key === "soudGun") return 1;
    if (extra.key === "soudCa1400") return Math.max(1, Math.ceil(standoffs / 15));
    if (extra.key === "groutSika" || extra.key === "chemset") return Math.max(1, Math.ceil(standoffs / 30));
    if (extra.key === "concreteFixings" || extra.key.includes("DomeNuts") || extra.key === "gs1000Rod") return Math.max(1, Math.ceil(standoffs / 4));
    return Math.max(1, standoffs);
  }
  function availableExtras(){
    if (isSemiBalustrade()) {
      const extras = [];
      const enduro = factoryEnduroShieldLine();
      extras.push({
        key:"enduroShield",
        title:"Factory applied EnduroShield",
        qty:`${enduro.qty}m2`,
        price:"$65/m2",
        desc:enduro.note
      });
      const grout = semiGroutSikaLine();
      const mappedGrout = variantMap[grout.sku];
      extras.push({
        key:"groutSika",
        title:"Sika grout",
        qty:`x${grout.qty}`,
        price:mappedGrout?.price ? money(mappedGrout.price * grout.qty) : "Price pending",
        desc:grout.note
      });
      if (state.fixing === "base") {
        const chemset = semiChemsetLine();
        const mappedChemset = variantMap[chemset.sku];
        extras.push({
          key:"chemset",
          title:"Chemset",
          qty:`x${chemset.qty}`,
          price:mappedChemset?.price ? money(mappedChemset.price * chemset.qty) : "Price pending",
          desc:chemset.note
        });
        const fixings = semiConcreteFixingLine();
        const mappedFixings = variantMap[fixings.sku];
        extras.push({
          key:"concreteFixings",
          title:"Concrete fixing kit",
          qty:`x${fixings.qty}`,
          price:mappedFixings?.price ? money(mappedFixings.price * fixings.qty) : "Price pending",
          desc:fixings.note
        });
      }
      return extras;
    }
    if (isPinFixedBalustrade()) {
      const standoffs = pinFixedStandoffTotal();
      const enduro = factoryEnduroShieldLine();
      const grout = pinFixedSikaLine();
      const fixings = pinFixedConcreteFixingLine();
      const extras = [
        { key:"enduroShield", sku:enduro.sku, title:"Factory applied EnduroShield", qty:enduro.qty, unit:enduro.unit, desc:enduro.note },
        { key:"groutSika", sku:grout.sku, title:"Sika grout", qty:grout.qty, desc:grout.note },
        { key:"concreteFixings", sku:fixings.sku, title:"Concrete fixing kit", qty:fixings.qty, desc:fixings.note },
        ...pinFixedBalustrade.extras
      ];
      return extras.filter(extra => !extra.standoffDiameter || extra.standoffDiameter === state.pinStandoffDiameter).map(extra => {
        const qty = Number(extra.qty) || pinFixedExtraQty(extra, standoffs);
        const mapped = variantMap[extra.sku];
        return {
        key:extra.key,
        sku:extra.sku,
        title:extra.title,
        qty:extra.unit === "m2" ? `${qty}m2` : `x${qty}`,
        price:mapped?.price
          ? money(mapped.price * qty)
          : mapped?.variantId
          ? money(estimateLinePrice({ sku:extra.sku, qty }))
          : "Price pending",
        desc:extra.desc
        };
      });
    }
    const extras = [];
    const enduroArea = projectGlassAreaM2() * 2;
    const enduroQty = Math.max(1, Math.ceil(enduroArea));
    extras.push({
      key:"enduroShield",
      title:"Factory applied EnduroShield",
      qty:`${enduroQty}m2`,
      price:"$65/m2",
      desc:`Both sides of balustrade glass. ${enduroArea.toFixed(1)}m2 calculated, ${enduroQty}m2 charged.`
    });
    if (state.fixing === "core") {
      const grout = groutSikaLine();
      const mapped = variantMap[grout.sku];
      extras.push({
        key:"groutSika",
        title:"Sika grout",
        qty:`x${grout.qty}`,
        price:mapped?.price ? money(mapped.price * grout.qty) : "Price pending",
        desc:grout.note
      });
    }
    if (state.fixing === "base") {
      const chemset = chemsetLine();
      const mapped = variantMap[chemset.sku];
      extras.push({
        key:"chemset",
        title:"Chemset",
        qty:`x${chemset.qty}`,
        price:mapped?.price ? money(mapped.price * chemset.qty) : "Price pending",
        desc:chemset.note
      });
      const fixings = concreteFixingLine();
      const mappedFixings = variantMap[fixings.sku];
      extras.push({
        key:"concreteFixings",
        title:"Concrete fixing kit",
        qty:`x${fixings.qty}`,
        price:mappedFixings?.price ? money(mappedFixings.price * fixings.qty) : "Price pending",
        desc:fixings.note
      });
    }
    return extras;
  }
  function optionalExtrasHtml(){
    const extras = availableExtras();
    if (!extras.length) return `<div class="empty">No optional extras available for this setup.</div>`;
    return extras.map(item => {
      const selected = !!state.extras?.[item.key];
      return `<button type="button" class="extra-card ${selected ? "selected" : ""}" data-extra="${item.key}">
        <span><strong>${item.title}</strong><small>${item.desc}</small></span>
        <span class="extra-pill">${selected ? "Selected" : "Add"} ${item.qty} - ${item.price}</span>
      </button>`;
    }).join("");
  }
  function renderExtrasModal(){
    const list = $("optionalExtras");
    if (list) {
      list.innerHTML = optionalExtrasHtml();
      queueOptionalExtrasPriceRefresh();
    }
    const note = $("extrasModalNote");
    if (note) note.textContent = isPinFixedBalustrade()
      ? "Fixings must be selected to suit the supporting structure. If you are unsure whether to use timber lag screws, threaded rod or another fixing method, consult your builder, engineer or project certifier before ordering."
      : isSemiBalustrade()
      ? "Choose any optional fixing extras you want included with this semi-frameless balustrade project."
      : "Choose any extras you want included with this balustrade project.";
  }
  function queueOptionalExtrasPriceRefresh(){
    const extras = availableExtras();
    if (!extras.length) return;
    queueVariantPriceRefresh(extras.map(extra => ({ sku:extra.sku, qty:1 })));
  }
  function openExtrasModal(){
    renderExtrasModal();
    const modal = $("extrasModal");
    if (!modal) return;
    modal.classList.add("open");
    modal.setAttribute("aria-hidden","false");
  }
  function closeExtrasModal(){
    const modal = $("extrasModal");
    if (!modal) return;
    modal.classList.remove("open");
    modal.setAttribute("aria-hidden","true");
  }
  function clearOptionalExtras(){
    state.extras = { enduroShield:false, groutSika:false, chemset:false, concreteFixings:false };
  }
  function generateProjectBOM(){
    const combined = [];
    state.sides.slice(0,state.sideCount).forEach((side, index) => {
      const sideLines = withRunLength(side.runLength, () => generateBOM(selectedLayout(), false), index);
      sideLines.forEach(line => addLine(combined, line.sku, line.name, line.qty, line.note ? `Side ${String.fromCharCode(65+index)} &bull; ${line.note}` : `Side ${String.fromCharCode(65+index)}`, line.unit || "each"));
    });
    if (isSemiBalustrade()) {
      if (combined.length) addSemiBalustradeHardwareLines(combined);
      state.extras = state.extras || {};
      if (state.extras.enduroShield) {
        const extra = factoryEnduroShieldLine();
        addLine(combined, extra.sku, extra.name, extra.qty, extra.note, extra.unit || "each");
      }
      if (state.extras.groutSika) {
        const extra = semiGroutSikaLine();
        addLine(combined, extra.sku, extra.name, extra.qty, extra.note, extra.unit || "each");
      }
      if (state.fixing === "base" && state.extras.chemset) {
        const extra = semiChemsetLine();
        addLine(combined, extra.sku, extra.name, extra.qty, extra.note, extra.unit || "each");
      }
      if (state.fixing === "base" && state.extras.concreteFixings) {
        const extra = semiConcreteFixingLine();
        addLine(combined, extra.sku, extra.name, extra.qty, extra.note, extra.unit || "each");
      }
      return combined;
    }
    if (isPinFixedBalustrade()) {
      if (combined.length) addProjectHandrailLines(combined, currentRule());
      state.extras = state.extras || {};
      if (state.extras.enduroShield) {
        const extra = factoryEnduroShieldLine();
        addLine(combined, extra.sku, extra.name, extra.qty, extra.note, extra.unit || "each");
      }
      if (state.extras.groutSika) {
        const extra = pinFixedSikaLine();
        addLine(combined, extra.sku, extra.name, extra.qty, extra.note, extra.unit || "each");
      }
      if (state.extras.concreteFixings) {
        const extra = pinFixedConcreteFixingLine();
        addLine(combined, extra.sku, extra.name, extra.qty, extra.note, extra.unit || "each");
      }
      const standoffs = pinFixedStandoffTotal();
      pinFixedBalustrade.extras.forEach(extra => {
        if (!state.extras[extra.key]) return;
        if (extra.standoffDiameter && extra.standoffDiameter !== state.pinStandoffDiameter) return;
        const qty = pinFixedExtraQty(extra, standoffs);
        addLine(combined, extra.sku, extra.title, Math.max(1, qty), extra.desc);
      });
      return combined;
    }
    if (combined.length) addProjectHandrailLines(combined, currentRule());
    state.extras = state.extras || {};
    if (state.extras.enduroShield) {
      const extra = factoryEnduroShieldLine();
      addLine(combined, extra.sku, extra.name, extra.qty, extra.note, extra.unit || "each");
    }
    if (state.fixing === "core" && state.extras.groutSika) {
      const extra = groutSikaLine();
      addLine(combined, extra.sku, extra.name, extra.qty, extra.note, extra.unit || "each");
    }
    if (state.fixing === "base" && state.extras.chemset) {
      const extra = chemsetLine();
      addLine(combined, extra.sku, extra.name, extra.qty, extra.note, extra.unit || "each");
    }
    if (state.fixing === "base" && state.extras.concreteFixings) {
      const extra = concreteFixingLine();
      addLine(combined, extra.sku, extra.name, extra.qty, extra.note, extra.unit || "each");
    }
    return combined;
  }
  function mappedTotal(lines){
    let total = 0, estimatedTotal = 0, missing = [], unpriced = [];
    lines.forEach(line => {
      const mapped = variantMap[line.sku];
      if (!mapped?.variantId) missing.push(line.sku);
      if (mapped?.price) total += Number(mapped.price) * line.qty;
      else if (mapped?.variantId) unpriced.push(line.sku);
      estimatedTotal += estimateLinePrice(line);
    });
    return { total, estimatedTotal, missing, unpriced };
  }
  function svgDefs(){
    return `<defs><linearGradient id="glassGrad" x1="0" x2="0" y1="0" y2="1"><stop offset="0%" stop-color="#e9fbff" stop-opacity=".9"/><stop offset="100%" stop-color="#bdebf3" stop-opacity=".62"/></linearGradient><filter id="shadow" x="-30%" y="-30%" width="160%" height="180%"><feDropShadow dx="0" dy="8" stdDeviation="8" flood-color="#10201d" flood-opacity=".18"/></filter></defs>`;
  }
  function semiPostSvg(x, top, height, role){
    const fill = finishes[state.finish].colour;
    const stroke = state.finish === "white" ? "#9fa9a6" : "#31443f";
    const label = role === "corner90" ? "90 post" : role === "twoWay" ? "2-way post" : "1-way post";
    const labelY = top + height + 62;
    return `<g filter="url(#shadow)"><rect x="${x-8}" y="${top-24}" width="16" height="${height+44}" rx="2" fill="${fill}" stroke="${stroke}" stroke-width="2"/><rect x="${x-15}" y="${top+height+18}" width="30" height="7" rx="3" fill="${fill}" stroke="${stroke}"/></g><g><line x1="${x}" y1="${top+height+27}" x2="${x}" y2="${labelY-17}" class="gap-line"/><rect x="${x-42}" y="${labelY-18}" width="84" height="25" rx="9" fill="#fff" stroke="#d8e3df"/><text x="${x}" y="${labelY}" text-anchor="middle" class="svg-text small">${label}</text></g>`;
  }
  function semiElevationSvg(layout){
    if (!layout.valid) return `<div class="empty">${layout.message}</div>`;
    const rule = currentRule();
    const support = rule.support;
    const start = 78, top = support.railPosition === "top-glazed" ? 128 : 146, panelH = state.semiGlass === "1152laminated" ? 228 : 220, slab = top + panelH + 62;
    const scale = Math.max(0.2, Math.min(0.68, 980 / state.runLength));
    const leftAllowance = semiEndSetoutAllowance(state.activeSide, elevationShouldReverse() ? "right" : "left") * scale;
    const rightAllowance = semiEndSetoutAllowance(state.activeSide, elevationShouldReverse() ? "left" : "right") * scale;
    const postW = semiBalustrade.postWidth * scale;
    const insertMm = Number(layout.insert) || semiBalustrade.insert;
    const insert = insertMm * scale;
    const bodyStart = start + leftAllowance;
    let postX = bodyStart;
    const posts = [];
    const panels = [];
    const displayWidths = elevationShouldReverse() ? [...layout.widths].reverse() : layout.widths;
    const displayPosts = elevationShouldReverse() ? [...layout.posts].reverse() : layout.posts;
    const displayInserts = elevationShouldReverse()
      ? [...(layout.panelInserts || [])].reverse().map(pair => ({ left:pair.right, right:pair.left }))
      : (layout.panelInserts || []);
    displayWidths.forEach((w, i) => {
      const role = displayPosts[i]?.role || "twoWay";
      const leftInsertMm = Number(displayInserts[i]?.left) || insertMm;
      const rightInsertMm = Number(displayInserts[i]?.right) || insertMm;
      const leftInsert = leftInsertMm * scale;
      const rightInsert = rightInsertMm * scale;
      posts.push(semiPostSvg(postX + postW/2, top, panelH, role));
      const gx = postX + postW - leftInsert;
      const gw = Math.max(12, w * scale);
      panels.push(`<g><rect x="${gx}" y="${top}" width="${gw}" height="${panelH}" rx="4" class="glass-panel"/><line x1="${gx}" y1="${top}" x2="${gx}" y2="${top+panelH}" class="glass-edge"/><line x1="${gx+gw}" y1="${top}" x2="${gx+gw}" y2="${top+panelH}" class="glass-edge"/><text x="${gx+gw/2}" y="${top+panelH/2-8}" text-anchor="middle" class="svg-text">Semi glass</text><text x="${gx+gw/2}" y="${top+panelH/2+22}" text-anchor="middle" class="svg-text strong">${w}mm</text></g>`);
      postX += postW + (w * scale) - leftInsert - rightInsert;
      if (i === displayWidths.length - 1) posts.push(semiPostSvg(postX + postW/2, top, panelH, displayPosts[i+1]?.role || "oneWay"));
    });
    const fenceEnd = postX + postW;
    const overallEnd = fenceEnd + rightAllowance;
    const heightMarkerX = fenceEnd + 50;
    const width = Math.max(1080, heightMarkerX + 150), height = 520;
    const leftType = effectiveEnd(state.activeSide, elevationShouldReverse() ? "right" : "left");
    const rightType = effectiveEnd(state.activeSide, elevationShouldReverse() ? "left" : "right");
    const leftWall = leftType === "wall" ? `<rect x="${start-28}" y="${top-50}" width="18" height="${panelH+96}" fill="#d5d9d6"/>` : "";
    const rightWall = rightType === "wall" ? `<rect x="${fenceEnd+14}" y="${top-50}" width="18" height="${panelH+96}" fill="#d5d9d6"/>` : "";
    const heightLabel = `<g><line x1="${heightMarkerX}" y1="${top}" x2="${heightMarkerX}" y2="${top+panelH}" class="dim-line"/><line x1="${heightMarkerX-10}" y1="${top}" x2="${heightMarkerX+10}" y2="${top}" class="tick-line"/><line x1="${heightMarkerX-10}" y1="${top+panelH}" x2="${heightMarkerX+10}" y2="${top+panelH}" class="tick-line"/><text x="${heightMarkerX+14}" y="${top+panelH/2-4}" class="svg-text strong">${rule.glassHeight}mm</text><text x="${heightMarkerX+14}" y="${top+panelH/2+16}" class="svg-text small">glass height</text></g>`;
    const railY = support.railPosition === "top-glazed" ? top - 18 : top - 54;
    const rail = support.railPosition === "offset"
      ? `<g><rect x="${bodyStart}" y="${top+26}" width="${fenceEnd-bodyStart}" height="16" rx="4" fill="${finishes[state.finish].colour}" stroke="#40544e"/><text x="${(bodyStart+fenceEnd)/2}" y="${top+68}" text-anchor="middle" class="svg-text strong">Offset handrail fixed beside posts</text>${layout.posts.map((_,i)=>`<line x1="${bodyStart + i*((fenceEnd-bodyStart)/(layout.posts.length-1))}" y1="${top+14}" x2="${bodyStart + i*((fenceEnd-bodyStart)/(layout.posts.length-1))}" y2="${top+28}" stroke="#40544e" stroke-width="2"/>`).join("")}</g>`
      : `<g><rect x="${bodyStart}" y="${railY}" width="${fenceEnd-bodyStart}" height="18" rx="4" fill="${finishes[state.finish].colour}" stroke="#40544e"/><text x="${(bodyStart+fenceEnd)/2}" y="${railY-12}" text-anchor="middle" class="svg-text strong">${support.railPosition === "top-glazed" ? "3-edge: glass inserted into handrail" : "2-edge: handrail above glass with visible gap"}</text></g>`;
    const footer = `${state.fixing === "core" ? "1400mm core-drill posts with dress rings" : "1050mm welded base-plated posts with domical covers"} - ${support.label}`;
    const allowanceText = layout.setoutAllowance ? `<text x="${start}" y="${height-64}" class="svg-text small">${semiSetoutNote(state.activeSide)}.</text>` : "";
    return `<svg viewBox="0 0 ${width} ${height}" preserveAspectRatio="xMidYMid meet" role="img">${svgDefs()}<rect width="${width}" height="${height}" fill="#fbfdfc"/><rect x="0" y="${slab}" width="${width}" height="${height-slab}" fill="#e8e2d6"/><line x1="${start}" y1="66" x2="${overallEnd}" y2="66" class="dim-line"/><line x1="${start}" y1="54" x2="${start}" y2="78" class="tick-line"/><line x1="${overallEnd}" y1="54" x2="${overallEnd}" y2="78" class="tick-line"/><text x="${(start+overallEnd)/2}" y="42" text-anchor="middle" class="title-text">${fmt(state.runLength)} semi-frameless balustrade run</text>${leftWall}${rightWall}${panels.join("")}${posts.join("")}${rail}<line x1="${start-10}" y1="${slab}" x2="${overallEnd+10}" y2="${slab}" class="datum"/>${heightLabel}<text x="${start}" y="${height-42}" class="svg-text strong">${footer}</text>${allowanceText}<text x="${width/2}" y="${height-18}" text-anchor="middle" class="svg-text strong">Balustrade requirements are site-specific. Confirm post, fixing and compliance details before ordering.</text></svg>`;
  }
  function pinFixedElevationSvg(layout){
    if (!layout.valid) return `<div class="empty">${layout.message}</div>`;
    const rule = currentRule();
    const start = 80, scale = Math.max(0.22, Math.min(0.72, 980 / state.runLength));
    const panelH = 250, top = 102, slab = top + panelH + 42;
    const reverse = elevationShouldReverse();
    const displayWidths = reverse ? [...layout.widths].reverse() : layout.widths;
    const leftEnd = reverse ? "right" : "left";
    const rightEnd = reverse ? "left" : "right";
    const leftEndGap = endNeedsGapForSide(state.activeSide, leftEnd) ? layout.gap : 0;
    const rightEndGap = endNeedsGapForSide(state.activeSide, rightEnd) ? layout.gap : 0;
    let x = start + leftEndGap * scale;
    const standoffFill = finishes[state.finish].colour;
    const standoffStroke = state.finish === "white" ? "#9fa9a6" : "#263a35";
    const panels = displayWidths.map((w,i) => {
      const pw = w * scale;
      const holeLayout = pinFixedHoleLayout(w);
      const holes = holeLayout.columns.map(offset => {
        const cx = x + offset * scale;
        const rows = holeLayout.rowsFromBottom.map(bottomOffset => top + panelH - bottomOffset * (panelH / rule.glassHeight));
        return rows.map(cy => `<circle cx="${cx}" cy="${cy}" r="${state.pinStandoffDiameter === "50" ? 7 : 5.8}" fill="${standoffFill}" stroke="${standoffStroke}" stroke-width="2"/><circle cx="${cx}" cy="${cy}" r="2" fill="#fbfdfc" opacity=".8"/>`).join("");
      }).join("");
      const html = `<g><rect x="${x}" y="${top}" width="${pw}" height="${panelH}" rx="4" class="glass-panel"/><line x1="${x}" y1="${top}" x2="${x}" y2="${top+panelH}" class="glass-edge"/><line x1="${x+pw}" y1="${top}" x2="${x+pw}" y2="${top+panelH}" class="glass-edge"/><text x="${x+pw/2}" y="${top+panelH/2-8}" text-anchor="middle" class="svg-text">Pin-fixed glass</text><text x="${x+pw/2}" y="${top+panelH/2+22}" text-anchor="middle" class="svg-text strong">${w}mm</text>${holes}</g>`;
      x += pw;
      if (i < displayWidths.length - 1) {
        const gx = x, gw = layout.gap * scale;
        x += gw;
        return html + `<text x="${gx+gw/2}" y="${slab+40}" text-anchor="middle" class="svg-text small">${layout.gap}mm</text><line x1="${gx+gw/2}" y1="${top+panelH+4}" x2="${gx+gw/2}" y2="${slab+20}" class="gap-line"/>`;
      }
      return html;
    }).join("");
    const glassStart = start + leftEndGap * scale;
    const glassEnd = x;
    const fenceEnd = glassEnd + rightEndGap * scale;
    const heightMarkerX = fenceEnd + 56;
    const rail = `<g><rect x="${glassStart}" y="${top-18}" width="${glassEnd-glassStart}" height="14" rx="4" fill="${finishes[state.finish].colour}" stroke="#40544e"/><text x="${(glassStart+glassEnd)/2}" y="${top-30}" text-anchor="middle" class="svg-text strong">${rule.handrail}</text></g>`;
    const heightLabel = `<g><line x1="${heightMarkerX}" y1="${top}" x2="${heightMarkerX}" y2="${top+panelH}" class="dim-line"/><line x1="${heightMarkerX-10}" y1="${top}" x2="${heightMarkerX+10}" y2="${top}" class="tick-line"/><line x1="${heightMarkerX-10}" y1="${top+panelH}" x2="${heightMarkerX+10}" y2="${top+panelH}" class="tick-line"/><text x="${heightMarkerX+14}" y="${top+panelH/2-4}" class="svg-text strong">1280mm</text><text x="${heightMarkerX+14}" y="${top+panelH/2+16}" class="svg-text small">glass height</text></g>`;
    const width = Math.max(1080, heightMarkerX + 150), height = 520;
    return `<svg viewBox="0 0 ${width} ${height}" preserveAspectRatio="xMidYMid meet" role="img">${svgDefs()}<rect width="${width}" height="${height}" fill="#fbfdfc"/><rect x="0" y="${slab}" width="${width}" height="${height-slab}" fill="#e8e2d6"/><line x1="${start}" y1="64" x2="${fenceEnd}" y2="64" class="dim-line"/><line x1="${start}" y1="52" x2="${start}" y2="76" class="tick-line"/><line x1="${fenceEnd}" y1="52" x2="${fenceEnd}" y2="76" class="tick-line"/><text x="${(start+fenceEnd)/2}" y="42" text-anchor="middle" class="title-text">${fmt(state.runLength)} pin-fixed balustrade run</text>${rail}${panels}<line x1="${start-10}" y1="${slab}" x2="${fenceEnd+10}" y2="${slab}" class="datum"/>${heightLabel}<text x="${start}" y="${height-42}" class="svg-text strong">${pinFixedStandoffName()} &bull; ${layout.standoffCount} standoffs total</text><text x="${width/2}" y="${height-18}" text-anchor="middle" class="svg-text strong">Fixings and compliance are site-specific. Confirm supporting structure before ordering.</text></svg>`;
  }
  function elevationSvg(layout=selectedLayout()){
    const rule = currentRule();
    if (!layout.valid) return `<div class="empty">${layout.message}</div>`;
    if (isSemiBalustrade()) return semiElevationSvg(layout);
    if (isPinFixedBalustrade()) return pinFixedElevationSvg(layout);
    const start = 80, scale = Math.max(0.22, Math.min(0.72, 980 / state.runLength));
    const panelH = state.glass === "15" ? 230 : 220;
    const glassHeightMm = state.glass === "15" ? 1000 : 970;
    const glassClearance = state.fixing === "base" ? basePlateGlassClearance() : 55;
      const top = 112, glassBottom = top + panelH, slab = glassBottom + glassClearance;
    const railH = state.glass === "15" ? 14 : 10;
    const railY = top - railH;
    const reverse = elevationShouldReverse();
    const logicalLeftType = effectiveEnd(state.activeSide, "left");
    const logicalRightType = effectiveEnd(state.activeSide, "right");
    const leftType = reverse ? logicalRightType : logicalLeftType;
    const rightType = reverse ? logicalLeftType : logicalRightType;
    const leftEnd = reverse ? "right" : "left";
    const rightEnd = reverse ? "left" : "right";
    const displayWidths = reverse ? [...layout.widths].reverse() : layout.widths;
  const leftEndGap = endNeedsGapForSide(state.activeSide, leftEnd) ? layout.gap : 0;
  const rightEndGap = endNeedsGapForSide(state.activeSide, rightEnd) ? layout.gap : 0;
    const glassStart = start + leftEndGap * scale;
    let x = glassStart;
    const parts = displayWidths.map((w,i) => {
      const pw = w * scale;
      const sp1 = x + pw*.22, sp2 = x + pw*.78;
        const html = `<g><rect x="${x}" y="${top}" width="${pw}" height="${panelH}" rx="4" class="glass-panel"/><line x1="${x}" y1="${top}" x2="${x}" y2="${top+panelH}" class="glass-edge"/><line x1="${x+pw}" y1="${top}" x2="${x+pw}" y2="${top+panelH}" class="glass-edge"/><text x="${x+pw/2}" y="${top+panelH/2-8}" text-anchor="middle" class="svg-text">Glass</text><text x="${x+pw/2}" y="${top+panelH/2+22}" text-anchor="middle" class="svg-text strong">${w}mm</text>${spigot(sp1,slab,glassBottom,rule)}${spigot(sp2,slab,glassBottom,rule)}</g>`;
      x += pw;
      if (i < displayWidths.length-1) {
        const gx = x, gw = layout.gap * scale;
        x += gw;
        return html + `<text x="${gx+gw/2}" y="${slab+42}" text-anchor="middle" class="svg-text small">${layout.gap}mm</text><line x1="${gx+gw/2}" y1="${top+panelH+6}" x2="${gx+gw/2}" y2="${slab+22}" class="gap-line"/>`;
      }
      return html;
    }).join("");
    const glassEnd = x;
    const fenceEnd = glassEnd + rightEndGap * scale;
    const formatGap = value => Number.isInteger(Number(value)) ? Number(value) : Number(value).toFixed(1);
    const wallGapMark = (gapStart, gapEnd, label) => `<text x="${(gapStart+gapEnd)/2}" y="${slab+42}" text-anchor="middle" class="svg-text small">${formatGap(label)}mm</text><line x1="${(gapStart+gapEnd)/2}" y1="${top+panelH+6}" x2="${(gapStart+gapEnd)/2}" y2="${slab+22}" class="gap-line"/>`;
    const wallGapMarks = `${leftEndGap ? wallGapMark(start,glassStart,leftEndGap) : ""}${rightEndGap ? wallGapMark(glassEnd,fenceEnd,rightEndGap) : ""}`;
    const wallBracket = (x, side) => `<g filter="url(#shadow)"><rect x="${x}" y="${railY-5}" width="16" height="${railH+10}" rx="3" fill="${finishes[state.finish].colour}" stroke="#40544e"/><line x1="${side === "left" ? x+16 : x}" y1="${railY+railH/2}" x2="${side === "left" ? glassStart+12 : glassEnd-12}" y2="${railY+railH/2}" stroke="#40544e" stroke-width="3"/></g>`;
    const leftWall = leftType === "wall" ? `<rect x="${start-24}" y="${top-52}" width="18" height="${panelH+88}" fill="#d5d9d6"/><text x="${start-52}" y="${top+panelH/2}" text-anchor="middle" class="svg-text small" transform="rotate(-90 ${start-52} ${top+panelH/2})">Wall</text>${wallBracket(start-38,"left")}` : `<text x="${start}" y="${top-34}" text-anchor="start" class="svg-text small">${endLabel(leftType,state.activeSide,leftEnd)}</text>`;
    const rightWall = rightType === "wall" ? `<rect x="${fenceEnd+6}" y="${top-52}" width="18" height="${panelH+88}" fill="#d5d9d6"/><text x="${fenceEnd+48}" y="${top+panelH/2}" text-anchor="middle" class="svg-text small" transform="rotate(90 ${fenceEnd+48} ${top+panelH/2})">Wall</text>${wallBracket(fenceEnd+26,"right")}` : `<text x="${fenceEnd}" y="${top-34}" text-anchor="end" class="svg-text small">${endLabel(rightType,state.activeSide,rightEnd)}</text>`;
    const heightMarkerX = fenceEnd + (rightType === "wall" ? 100 : 52);
    const clearanceMarkerX = heightMarkerX + 92;
    const heightLabel = `<g><line x1="${heightMarkerX}" y1="${top}" x2="${heightMarkerX}" y2="${glassBottom}" class="dim-line"/><line x1="${heightMarkerX-10}" y1="${top}" x2="${heightMarkerX+10}" y2="${top}" class="tick-line"/><line x1="${heightMarkerX-10}" y1="${glassBottom}" x2="${heightMarkerX+10}" y2="${glassBottom}" class="tick-line"/><text x="${heightMarkerX+14}" y="${top+panelH/2-4}" class="svg-text strong">${glassHeightMm}mm</text><text x="${heightMarkerX+14}" y="${top+panelH/2+16}" class="svg-text small">glass height</text></g>`;
    const clearanceLabel = state.fixing === "base"
      ? `<g><line x1="${clearanceMarkerX}" y1="${top+panelH}" x2="${clearanceMarkerX}" y2="${slab}" class="dim-line"/><line x1="${clearanceMarkerX-10}" y1="${top+panelH}" x2="${clearanceMarkerX+10}" y2="${top+panelH}" class="tick-line"/><line x1="${clearanceMarkerX-10}" y1="${slab}" x2="${clearanceMarkerX+10}" y2="${slab}" class="tick-line"/><text x="${clearanceMarkerX+14}" y="${top+panelH+glassClearance/2+5}" class="svg-text strong">${glassClearance}mm clearance</text></g>`
      : "";
    const width = Math.max(1080, state.fixing === "base" ? clearanceMarkerX + 180 : heightMarkerX + 150), height = 520;
    return `<svg viewBox="0 0 ${width} ${height}" preserveAspectRatio="xMidYMid meet" role="img">${svgDefs()}<rect width="${width}" height="${height}" fill="#fbfdfc"/><rect x="0" y="${slab}" width="${width}" height="${height-slab}" fill="#e8e2d6"/><line x1="${start}" y1="64" x2="${fenceEnd}" y2="64" class="dim-line"/><line x1="${start}" y1="52" x2="${start}" y2="76" class="tick-line"/><line x1="${fenceEnd}" y1="52" x2="${fenceEnd}" y2="76" class="tick-line"/><text x="${(start+fenceEnd)/2}" y="42" text-anchor="middle" class="title-text">${fmt(state.runLength)} balustrade run</text>${leftWall}${rightWall}<rect x="${glassStart}" y="${railY}" width="${glassEnd-glassStart}" height="${railH}" rx="4" fill="${finishes[state.finish].colour}" stroke="#41544f"/><text x="${(glassStart+glassEnd)/2}" y="${railY-12}" text-anchor="middle" class="svg-text strong">${rule.handrail}</text>${parts}${wallGapMarks}<line x1="${start-10}" y1="${slab}" x2="${fenceEnd+10}" y2="${slab}" class="datum"/>${heightLabel}${clearanceLabel}<text x="${start}" y="${height-42}" class="svg-text strong">${rule.spigotName} ${state.fixing === "core" ? "core drilled" : "base plated"} spigots - ${rule.title}</text><text x="${width/2}" y="${height-18}" text-anchor="middle" class="svg-text strong">Balustrade requirements are site-specific. Purchaser/installer/certifier must confirm suitability and compliance.</text></svg>`;
  }
    function spigot(cx, slab, glassBottom, rule){
      const fill = finishes[state.finish].colour;
      const stroke = state.finish === "white" ? "#9fa9a6" : "#31443f";
      const bodyTop = glassBottom - 12;
      if (state.fixing === "base") {
        const plateY = slab - 7;
        const bodyHeight = Math.max(12, plateY - bodyTop + 1);
        return `<g filter="url(#shadow)"><rect x="${cx-6}" y="${bodyTop}" width="12" height="${bodyHeight}" rx="3" fill="${fill}" stroke="${stroke}"/><rect x="${cx-15}" y="${plateY}" width="30" height="6" rx="3" fill="${fill}" stroke="${stroke}"/></g>`;
      }
      const bodyHeight = slab + 14 - bodyTop;
      return `<g filter="url(#shadow)"><rect x="${cx-5}" y="${bodyTop}" width="10" height="${bodyHeight}" rx="4" fill="${fill}" stroke="${stroke}"/></g>`;
    }
  function pinFixedIsoSvg(){
    const width = 1100, height = 560;
    const lengths = state.sides.slice(0,state.sideCount).map(s => Number(s.runLength)||0);
    const planPoints = [{x:0,y:0}];
    planPoints.push({x:lengths[0]||0,y:0});
    if (state.sideCount >= 2) planPoints.push({x:lengths[0]||0,y:lengths[1]||0});
    if (state.sideCount >= 3) planPoints.push({x:(lengths[0]||0)-(lengths[2]||0),y:lengths[1]||0});
    const rawIso = (pt, scale) => ({ x:(pt.x - pt.y) * scale, y:(pt.x + pt.y) * scale * .48 });
    const raw = planPoints.map(pt => rawIso(pt, 1));
    const minX = Math.min(...raw.map(pt=>pt.x)), maxX = Math.max(...raw.map(pt=>pt.x));
    const minY = Math.min(...raw.map(pt=>pt.y)), maxY = Math.max(...raw.map(pt=>pt.y));
    const scale = Math.min(620 / Math.max(1, maxX-minX), 260 / Math.max(1, maxY-minY), .055);
    const offset = { x:width/2 - ((minX+maxX)/2)*scale, y:340 - ((minY+maxY)/2)*scale };
    const project = (pt) => {
      const projected = rawIso(pt, scale);
      return { x:projected.x + offset.x, y:projected.y + offset.y };
    };
    const heightVec = { x:0, y:-190 };
    const p = (pt) => `${pt.x},${pt.y}`;
    const add = (a,b) => ({ x:a.x+b.x, y:a.y+b.y });
    const sub = (a,b) => ({ x:a.x-b.x, y:a.y-b.y });
    const mul = (v,n) => ({ x:v.x*n, y:v.y*n });
    const points = planPoints.map(project);
    const deckPath = points.map((pt, i) => `${i ? "L" : "M"} ${pt.x} ${pt.y}`).join(" ");
    let panels = "", rails = "", pins = "";
    for (let i=0;i<state.sideCount;i++) {
      const a = points[i], b = points[i+1];
      const topA = add(a, heightVec), topB = add(b, heightVec);
      const sideLayout = withRunLength(lengths[i], () => selectedLayout(), i);
      const panelCount = sideLayout.valid ? sideLayout.count : 1;
      panels += `<polygon points="${p(a)} ${p(b)} ${p(topB)} ${p(topA)}" fill="url(#glassGrad)" stroke="#8fc6cf" stroke-width="2" opacity=".94" filter="url(#shadow)"/>`;
      rails += `<line x1="${topA.x}" y1="${topA.y-10}" x2="${topB.x}" y2="${topB.y-10}" stroke="${finishes[state.finish].colour}" stroke-width="9" stroke-linecap="round"/>`;
      for (let j=0;j<panelCount;j++) {
        const startT = j / panelCount;
        const endT = (j + 1) / panelCount;
        const w = sideLayout.valid ? sideLayout.widths[j] : 800;
        pinFixedHoleLayout(w).columns.forEach(offset => {
          const base = add(a, mul(sub(b,a), startT + (endT-startT) * (offset / w)));
          pinFixedHoleLayout(w).rowsFromBottom.forEach(bottomOffset => {
            const hole = add(base, mul(heightVec, bottomOffset / currentRule().glassHeight));
            pins += `<circle cx="${hole.x}" cy="${hole.y}" r="${state.pinStandoffDiameter === "50" ? 5 : 4}" fill="${finishes[state.finish].colour}" stroke="#263a35"/>`;
          });
        });
        if (j>0) {
          const edge = add(a, mul(sub(b,a), startT));
          const edgeTop = add(edge, heightVec);
          panels += `<line x1="${edge.x}" y1="${edge.y}" x2="${edgeTop.x}" y2="${edgeTop.y}" stroke="#8fc6cf" stroke-width="2" opacity=".75"/>`;
        }
      }
      const mid = add(a, mul(sub(b,a), .5));
      panels += `<text x="${mid.x}" y="${mid.y+34}" text-anchor="middle" class="svg-text strong">Side ${String.fromCharCode(65+i)}</text>`;
    }
    return `<svg viewBox="0 0 ${width} ${height}" preserveAspectRatio="xMidYMid meet" role="img">${svgDefs()}<rect width="${width}" height="${height}" fill="#fbfdfc"/><ellipse cx="560" cy="402" rx="400" ry="92" fill="#e8f0ec"/><path d="${deckPath}" fill="none" stroke="#d8d0c1" stroke-width="118" stroke-linecap="square" stroke-linejoin="round" opacity=".32"/><path d="${deckPath}" fill="none" stroke="#ece7dc" stroke-width="112" stroke-linecap="square" stroke-linejoin="round"/><path d="${deckPath}" fill="none" stroke="#cfc7b8" stroke-width="3" stroke-linecap="round" opacity=".7"/>${panels}${rails}${pins}<g><rect x="350" y="12" width="400" height="38" rx="6" fill="#fbfdfc" fill-opacity=".96"/><text x="550" y="38" text-anchor="middle" class="title-text">Pin-fixed balustrade preview</text></g><text x="550" y="488" text-anchor="middle" class="svg-text strong">${pinFixedStandoffName()} &bull; ${currentRule().handrail}</text><g transform="translate(70 430)"><rect x="0" y="0" width="410" height="76" rx="12" fill="#fff" stroke="#d8e3df"/><text x="18" y="28" class="svg-text strong">3D preview</text><text x="18" y="52" class="svg-text small">Illustrative only. Use elevation and BOM for exact hole counts.</text></g></svg>`;
  }
  function isoSvg(layout=selectedLayout()){
    const rule = currentRule();
    if (!layout.valid) return `<div class="empty">${layout.message}</div>`;
    if (isSemiBalustrade()) return semiIsoSvg(layout);
    if (isPinFixedBalustrade()) return pinFixedIsoSvg();
    const width = 1100, height = 560;
    const lengths = state.sides.slice(0,state.sideCount).map(s => Number(s.runLength)||0);
    const planPoints = [{x:0,y:0}];
    planPoints.push({x:lengths[0]||0,y:0});
    if (state.sideCount >= 2) planPoints.push({x:lengths[0]||0,y:lengths[1]||0});
    if (state.sideCount >= 3) planPoints.push({x:(lengths[0]||0)-(lengths[2]||0),y:lengths[1]||0});
    const rawIso = (pt, scale) => ({ x:(pt.x - pt.y) * scale, y:(pt.x + pt.y) * scale * .48 });
    const raw = planPoints.map(pt => rawIso(pt, 1));
    const minX = Math.min(...raw.map(pt=>pt.x)), maxX = Math.max(...raw.map(pt=>pt.x));
    const minY = Math.min(...raw.map(pt=>pt.y)), maxY = Math.max(...raw.map(pt=>pt.y));
    const scale = Math.min(620 / Math.max(1, maxX-minX), 260 / Math.max(1, maxY-minY), .055);
    const offset = { x:width/2 - ((minX+maxX)/2)*scale, y:340 - ((minY+maxY)/2)*scale };
    const project = (pt) => {
      const projected = rawIso(pt, scale);
      return { x:projected.x + offset.x, y:projected.y + offset.y };
    };
    const heightVec = { x:0, y:-178 };
    const railH = state.glass === "15" ? 14 : 10;
    const finish = finishes[state.finish].colour;
    const p = (pt) => `${pt.x},${pt.y}`;
    const add = (a,b) => ({ x:a.x+b.x, y:a.y+b.y });
    const sub = (a,b) => ({ x:a.x-b.x, y:a.y-b.y });
    const mul = (v,n) => ({ x:v.x*n, y:v.y*n });
    const points = planPoints.map(project);
    const deckPath = points.map((pt, i) => `${i ? "L" : "M"} ${pt.x} ${pt.y}`).join(" ");
    let panels = "";
    let spigots = "";
    let rails = "";
    for (let i=0;i<state.sideCount;i++) {
      const a = points[i], b = points[i+1];
      const topA = add(a, heightVec), topB = add(b, heightVec);
      const sideLayout = withRunLength(lengths[i], () => selectedLayout(), i);
      const panelCount = sideLayout.valid ? sideLayout.count : 1;
      panels += `<polygon points="${p(a)} ${p(b)} ${p(topB)} ${p(topA)}" fill="url(#glassGrad)" stroke="#8fc6cf" stroke-width="2" opacity=".94" filter="url(#shadow)"/>`;
      for (let j=1;j<panelCount;j++) {
        const t = j / panelCount;
        const edge = add(a, mul(sub(b,a), t));
        const edgeTop = add(edge, heightVec);
        panels += `<line x1="${edge.x}" y1="${edge.y}" x2="${edgeTop.x}" y2="${edgeTop.y}" stroke="#8fc6cf" stroke-width="2" opacity=".75"/>`;
      }
      rails += `<line x1="${topA.x}" y1="${topA.y-railH/2}" x2="${topB.x}" y2="${topB.y-railH/2}" stroke="${finish}" stroke-width="${railH}" stroke-linecap="round"/><line x1="${topA.x}" y1="${topA.y-railH-5}" x2="${topB.x}" y2="${topB.y-railH-5}" stroke="#40544e" stroke-width="1.5" opacity=".6"/>`;
      for (let s=0;s<panelCount*2;s++) {
        const t = (s+.5) / (panelCount*2);
        const base = add(a, mul(sub(b,a), t));
      spigots += `<rect x="${base.x-3.25}" y="${base.y-16}" width="6.5" height="42" rx="3.25" fill="#657772"/>`;
      }
      const mid = add(a, mul(sub(b,a), .5));
      panels += `<text x="${mid.x}" y="${mid.y+34}" text-anchor="middle" class="svg-text strong">Side ${String.fromCharCode(65+i)}</text>`;
    }
    const wallStart = effectiveEnd(0, "left") === "wall" ? `<polygon points="${p(add(points[0],{x:-20,y:12}))} ${p(add(points[0],{x:18,y:-8}))} ${p(add(add(points[0],{x:18,y:-8}),heightVec))} ${p(add(add(points[0],{x:-20,y:12}),heightVec))}" fill="#d9ddda" stroke="#b8c1bd"/>` : "";
    const finalPoint = points[state.sideCount];
    const wallEnd = effectiveEnd(state.sideCount-1, "right") === "wall" ? `<polygon points="${p(add(finalPoint,{x:-18,y:8}))} ${p(add(finalPoint,{x:22,y:-10}))} ${p(add(add(finalPoint,{x:22,y:-10}),heightVec))} ${p(add(add(finalPoint,{x:-18,y:8}),heightVec))}" fill="#d9ddda" stroke="#b8c1bd"/>` : "";
    return `<svg viewBox="0 0 ${width} ${height}" preserveAspectRatio="xMidYMid meet" role="img">${svgDefs()}<rect width="${width}" height="${height}" fill="#fbfdfc"/><ellipse cx="560" cy="402" rx="400" ry="92" fill="#e8f0ec"/><path d="${deckPath}" fill="none" stroke="#d8d0c1" stroke-width="118" stroke-linecap="square" stroke-linejoin="round" opacity=".32"/><path d="${deckPath}" fill="none" stroke="#ece7dc" stroke-width="112" stroke-linecap="square" stroke-linejoin="round"/><path d="${deckPath}" fill="none" stroke="#cfc7b8" stroke-width="3" stroke-linecap="round" opacity=".7"/>${wallStart}${wallEnd}${panels}${spigots}${rails}<g><rect x="410" y="12" width="280" height="38" rx="6" fill="#fbfdfc" fill-opacity=".96"/><text x="550" y="38" text-anchor="middle" class="title-text">3D balustrade preview</text></g><text x="550" y="488" text-anchor="middle" class="svg-text strong">${rule.title} &bull; ${rule.handrail}</text><g transform="translate(70 430)"><rect x="0" y="0" width="390" height="76" rx="12" fill="#fff" stroke="#d8e3df"/><text x="18" y="28" class="svg-text strong">3D preview</text><text x="18" y="52" class="svg-text small">Illustrative only. Use elevation and material list for exact sizes.</text></g></svg>`;
  }
  function semiIsoSvg(){
    const width = 1100, height = 560;
    const lengths = state.sides.slice(0,state.sideCount).map(s => Number(s.runLength)||0);
    const planPoints = [{x:0,y:0}];
    planPoints.push({x:lengths[0]||0,y:0});
    if (state.sideCount >= 2) planPoints.push({x:lengths[0]||0,y:lengths[1]||0});
    if (state.sideCount >= 3) planPoints.push({x:(lengths[0]||0)-(lengths[2]||0),y:lengths[1]||0});
    const rawIso = (pt, scale) => ({ x:(pt.x - pt.y) * scale, y:(pt.x + pt.y) * scale * .48 });
    const raw = planPoints.map(pt => rawIso(pt, 1));
    const minX = Math.min(...raw.map(pt=>pt.x)), maxX = Math.max(...raw.map(pt=>pt.x));
    const minY = Math.min(...raw.map(pt=>pt.y)), maxY = Math.max(...raw.map(pt=>pt.y));
    const scale = Math.min(620 / Math.max(1, maxX-minX), 260 / Math.max(1, maxY-minY), .055);
    const offset = { x:width/2 - ((minX+maxX)/2)*scale, y:340 - ((minY+maxY)/2)*scale };
    const project = (pt) => {
      const projected = rawIso(pt, scale);
      return { x:projected.x + offset.x, y:projected.y + offset.y };
    };
    const heightVec = { x:0, y:-178 };
    const finish = finishes[state.finish].colour;
    const p = (pt) => `${pt.x},${pt.y}`;
    const add = (a,b) => ({ x:a.x+b.x, y:a.y+b.y });
    const sub = (a,b) => ({ x:a.x-b.x, y:a.y-b.y });
    const mul = (v,n) => ({ x:v.x*n, y:v.y*n });
    const postShade = state.finish === "white" ? "#d8dfdc" : "#0d1715";
    const drawPost = (base, role) => {
      const top = add(base, heightVec);
      const bodyHeight = base.y - top.y + 18;
      const plate = state.fixing === "base"
        ? `<rect x="${base.x-10}" y="${base.y+13}" width="20" height="5" rx="2" fill="${finish}" stroke="#263a35" stroke-width="1.5"/>`
        : `<ellipse cx="${base.x}" cy="${base.y+16}" rx="9" ry="3" fill="${postShade}" opacity=".3"/>`;
      return `<g data-role="semi-3d-post" filter="url(#shadow)">
        <rect x="${base.x-4.5}" y="${top.y}" width="9" height="${bodyHeight}" rx="1.5" fill="${finish}" stroke="#263a35" stroke-width="1.5"/>
        <rect x="${base.x+4.5}" y="${top.y+3}" width="3" height="${bodyHeight-6}" rx="1" fill="${postShade}" opacity=".45"/>
        <rect x="${base.x-5.5}" y="${top.y-4}" width="11" height="4" rx="1.5" fill="${finish}" stroke="#263a35" stroke-width="1.2"/>
        ${plate}
      </g>`;
    };
    const points = planPoints.map(project);
    const deckPath = points.map((pt, i) => `${i ? "L" : "M"} ${pt.x} ${pt.y}`).join(" ");
    let panels = "", posts = "", rails = "";
    const drawnPosts = new Set();
    for (let i=0;i<state.sideCount;i++) {
      const a = points[i], b = points[i+1];
      const topA = add(a, heightVec), topB = add(b, heightVec);
      const sideLayout = withRunLength(lengths[i], () => selectedLayout(), i);
      const panelCount = sideLayout.valid ? sideLayout.count : 1;
      panels += `<polygon points="${p(a)} ${p(b)} ${p(topB)} ${p(topA)}" fill="url(#glassGrad)" stroke="#8fc6cf" stroke-width="2" opacity=".94" filter="url(#shadow)"/>`;
      const railOffset = state.supportSystem === "offset_handrail" ? { x:0, y:38 } : state.supportSystem === "three_edge_support" ? { x:0, y:-6 } : { x:0, y:-20 };
      const railA = add(topA, railOffset), railB = add(topB, railOffset);
      rails += `<line x1="${railA.x}" y1="${railA.y}" x2="${railB.x}" y2="${railB.y}" stroke="${finish}" stroke-width="${state.supportSystem === "offset_handrail" ? 7 : 9}" stroke-linecap="round" opacity=".92"/>`;
      for (let j=0;j<=panelCount;j++) {
        const t = j / panelCount;
        const base = add(a, mul(sub(b,a), t));
        const role = sideLayout.valid
          ? (j === 0 ? sideLayout.posts[0]?.role : j === panelCount ? sideLayout.posts[sideLayout.posts.length-1]?.role : "twoWay")
          : "twoWay";
        const key = `${Math.round(base.x)}:${Math.round(base.y)}`;
        if (!drawnPosts.has(key)) {
          posts += drawPost(base, role);
          drawnPosts.add(key);
        }
      }
      for (let j=1;j<panelCount;j++) {
        const t = j / panelCount;
        const edge = add(a, mul(sub(b,a), t));
        const edgeTop = add(edge, heightVec);
        panels += `<line x1="${edge.x}" y1="${edge.y}" x2="${edgeTop.x}" y2="${edgeTop.y}" stroke="#8fc6cf" stroke-width="2" opacity=".75"/>`;
      }
      const mid = add(a, mul(sub(b,a), .5));
      panels += `<text x="${mid.x}" y="${mid.y+34}" text-anchor="middle" class="svg-text strong">Side ${String.fromCharCode(65+i)}</text>`;
    }
    const rule = currentRule();
    const support = semiBalustrade.supportSystems[state.supportSystem];
    const footer = `${rule.glassHeight}mm glass with ${state.fixing === "core" ? "1400mm core-drill" : "1050mm welded base-plated"} 50 x 50mm posts`;
    return `<svg viewBox="0 0 ${width} ${height}" preserveAspectRatio="xMidYMid meet" role="img">${svgDefs()}<rect width="${width}" height="${height}" fill="#fbfdfc"/><ellipse cx="560" cy="402" rx="400" ry="92" fill="#e8f0ec"/><path d="${deckPath}" fill="none" stroke="#d8d0c1" stroke-width="118" stroke-linecap="square" stroke-linejoin="round" opacity=".32"/><path d="${deckPath}" fill="none" stroke="#ece7dc" stroke-width="112" stroke-linecap="square" stroke-linejoin="round"/><path d="${deckPath}" fill="none" stroke="#cfc7b8" stroke-width="3" stroke-linecap="round" opacity=".7"/>${panels}${rails}${posts}<g><rect x="360" y="12" width="380" height="38" rx="6" fill="#fbfdfc" fill-opacity=".96"/><text x="550" y="38" text-anchor="middle" class="title-text">Semi-frameless balustrade preview</text></g><text x="550" y="488" text-anchor="middle" class="svg-text strong">${footer} - ${support.label}</text><g transform="translate(70 430)"><rect x="0" y="0" width="390" height="76" rx="12" fill="#fff" stroke="#d8e3df"/><text x="18" y="28" class="svg-text strong">3D preview</text><text x="18" y="52" class="svg-text small">Full-height posts shown. Use elevation and BOM for setout.</text></g></svg>`;
  }
  function semiPlanSvg(){
    const width = 1080, height = 640;
    const lengths = state.sides.slice(0,state.sideCount).map(s => Number(s.runLength)||0);
    const maxLen = Math.max(...lengths, 1);
    const horizontalScale = Math.min(620 / maxLen, .14);
    const verticalScale = Math.min(350 / maxLen, .14);
    const startX = 270, startY = 165;
    const sideA = lengths[0] || 0, sideB = lengths[1] || 0, sideC = lengths[2] || 0;
    const ax2 = startX + sideA * horizontalScale, by2 = startY + sideB * verticalScale, cx1 = ax2 - sideC * horizontalScale;
    const arrow = (x1,y1,x2,y2,label,below=false) => `<g><line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="#344842" stroke-width="2" marker-start="url(#arrowHead)" marker-end="url(#arrowHead)"/><text x="${(x1+x2)/2}" y="${(y1+y2)/2 + (below ? 28 : -12)}" text-anchor="middle" class="svg-text strong">${label}</text></g>`;
    const drawRun = (label,x1,y1,x2,y2,index) => {
      const active = state.activeSide === index;
      const vertical = Math.abs(y2-y1) > Math.abs(x2-x1);
      const length = lengths[index] || 1;
      const layout = withRunLength(length, () => selectedLayout(), index);
      const ix = (mm) => x1 + (x2-x1) * (mm / length);
      const iy = (mm) => y1 + (y2-y1) * (mm / length);
      const leftAllowance = layout.valid ? semiEndSetoutAllowance(index, "left") : 0;
      const bodyLength = layout.valid ? layout.layoutRunLength || Math.max(1, length - semiSetoutAllowance(index)) : length;
      let pos = leftAllowance, segments = "";
      if (layout.valid) {
        layout.widths.forEach((w,i) => {
          const postStart = pos;
          const leftInsert = Number(layout.panelInserts?.[i]?.left) || Number(layout.insert) || semiBalustrade.insert;
          const rightInsert = Number(layout.panelInserts?.[i]?.right) || Number(layout.insert) || semiBalustrade.insert;
          const glassStart = pos + semiBalustrade.postWidth - leftInsert;
          const glassEnd = glassStart + w;
          segments += `<line x1="${ix(glassStart)}" y1="${iy(glassStart)}" x2="${ix(glassEnd)}" y2="${iy(glassEnd)}" stroke="#dff4f7" stroke-width="${active ? 18 : 14}" stroke-linecap="butt"/><line x1="${ix(glassStart)}" y1="${iy(glassStart)}" x2="${ix(glassEnd)}" y2="${iy(glassEnd)}" stroke="#6fb8c4" stroke-width="${active ? 4 : 3}"/><text x="${ix((glassStart+glassEnd)/2) + (vertical ? -42 : 0)}" y="${iy((glassStart+glassEnd)/2) + (vertical ? 4 : -24)}" text-anchor="middle" class="svg-text small">${w}mm</text>`;
          segments += `<rect x="${ix(postStart)-5}" y="${iy(postStart)-5}" width="10" height="10" rx="1" fill="${finishes[state.finish].colour}" stroke="#40544e"/>`;
          pos = postStart + semiBalustrade.postWidth + w - leftInsert - rightInsert;
          if (i === layout.widths.length - 1) segments += `<rect x="${ix(leftAllowance + bodyLength)-5}" y="${iy(leftAllowance + bodyLength)-5}" width="10" height="10" rx="1" fill="${finishes[state.finish].colour}" stroke="#40544e"/>`;
        });
      }
      const midX = (x1+x2)/2, midY = (y1+y2)/2;
      return `<g data-plan-side="${index}">${segments}<text x="${midX}" y="${midY + (vertical ? 0 : -48)}" text-anchor="middle" class="svg-text strong">${label}</text></g>`;
    };
    let runs = drawRun("Side A", startX, startY, ax2, startY, 0);
    if (state.sideCount >= 2) runs += drawRun("Side B", ax2, startY, ax2, by2, 1);
    if (state.sideCount >= 3) runs += drawRun("Side C", ax2, by2, cx1, by2, 2);
    const deckPlanPoints = [[startX,startY],[ax2,startY]];
    if (state.sideCount >= 2) deckPlanPoints.push([ax2,by2]);
    if (state.sideCount >= 3) deckPlanPoints.push([cx1,by2]);
    const deckPlanPath = deckPlanPoints.map((pt,i)=>`${i ? "L" : "M"} ${pt[0]} ${pt[1]}`).join(" ");
    const dims = `${arrow(startX,startY-70,ax2,startY-70,`A) ${fmt(sideA)}`)}${state.sideCount >= 2 ? arrow(ax2+70,startY,ax2+70,by2,`B) ${fmt(sideB)}`,true) : ""}${state.sideCount >= 3 ? arrow(cx1,by2+70,ax2,by2+70,`C) ${fmt(sideC)}`,true) : ""}`;
    return `<svg viewBox="0 0 ${width} ${height}" preserveAspectRatio="xMidYMid meet" role="img"><defs>${svgDefs().replace(/^<defs>|<\/defs>$/g,"")}<marker id="arrowHead" markerWidth="10" markerHeight="10" refX="5" refY="5" orient="auto-start-reverse"><path d="M0,0 L10,5 L0,10 z" fill="#344842"/></marker></defs><rect width="${width}" height="${height}" fill="#fbfdfc"/><text x="${width/2}" y="54" text-anchor="middle" class="title-text">${state.sideCount} side semi-frameless balustrade plan</text><path d="${deckPlanPath}" fill="none" stroke="#d7d0c2" stroke-width="104" stroke-linecap="square" stroke-linejoin="round" opacity=".38"/><path d="${deckPlanPath}" fill="none" stroke="#ebe5d8" stroke-width="96" stroke-linecap="square" stroke-linejoin="round" opacity=".95"/><text x="${width/2}" y="${by2+116}" text-anchor="middle" class="svg-text small">50 x 50mm posts shown as squares. ${semiSetoutNote(state.activeSide)}.</text>${dims}${runs}<g transform="translate(60 520)"><rect width="430" height="72" rx="14" fill="#fff" stroke="#d8e3df"/><text x="18" y="30" class="svg-text strong">Editing Side ${String.fromCharCode(65+state.activeSide)}</text><text x="18" y="54" class="svg-text small">Glass insertion varies within the post pocket range to suit the run.</text></g></svg>`;
  }
  function pinFixedPlanSvg(){
    const width = 1080, height = 640;
    const lengths = state.sides.slice(0,state.sideCount).map(s => Number(s.runLength)||0);
    const maxLen = Math.max(...lengths, 1);
    const horizontalScale = Math.min(620 / maxLen, .14);
    const verticalScale = Math.min(350 / maxLen, .14);
    const startX = 270, startY = 165;
    const sideA = lengths[0] || 0, sideB = lengths[1] || 0, sideC = lengths[2] || 0;
    const ax2 = startX + sideA * horizontalScale, by2 = startY + sideB * verticalScale, cx1 = ax2 - sideC * horizontalScale;
    const arrow = (x1,y1,x2,y2,label,below=false) => `<g><line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="#344842" stroke-width="2" marker-start="url(#arrowHead)" marker-end="url(#arrowHead)"/><text x="${(x1+x2)/2}" y="${(y1+y2)/2 + (below ? 28 : -12)}" text-anchor="middle" class="svg-text strong">${label}</text></g>`;
    const drawRun = (label,x1,y1,x2,y2,index) => {
      const active = state.activeSide === index;
      const vertical = Math.abs(y2-y1) > Math.abs(x2-x1);
      const sideLayout = withRunLength(lengths[index] || 0, () => selectedLayout(), index);
      const runLength = lengths[index] || 1;
      const ix = (mm) => x1 + (x2-x1) * (mm / runLength);
      const iy = (mm) => y1 + (y2-y1) * (mm / runLength);
      const labelOffsetX = vertical ? -42 : 0;
      const labelOffsetY = vertical ? 4 : -24;
      let pos = sideLayout.valid && endNeedsGapForSide(index,"left") ? sideLayout.gap : 0;
      let segments = "";
      if (sideLayout.valid) {
        sideLayout.widths.forEach((w,i) => {
          const sx = ix(pos), sy = iy(pos), ex = ix(pos+w), ey = iy(pos+w);
          const cx = ix(pos + w/2), cy = iy(pos + w/2);
          segments += `<line x1="${sx}" y1="${sy}" x2="${ex}" y2="${ey}" stroke="#dff4f7" stroke-width="${active ? 18 : 14}" stroke-linecap="butt"/><line x1="${sx}" y1="${sy}" x2="${ex}" y2="${ey}" stroke="#6fb8c4" stroke-width="${active ? 4 : 3}"/><text x="${cx+labelOffsetX}" y="${cy+labelOffsetY}" text-anchor="middle" class="svg-text small">${w}mm</text>`;
          pinFixedHoleLayout(w).columns.forEach(offset => {
            const hx = ix(pos + offset), hy = iy(pos + offset);
            segments += `<circle cx="${hx}" cy="${hy}" r="${state.pinStandoffDiameter === "50" ? 5 : 4}" fill="${finishes[state.finish].colour}" stroke="#40544e"/>`;
          });
          pos += w + (i < sideLayout.widths.length-1 ? sideLayout.gap : 0);
        });
      }
      return `<g data-plan-side="${index}">${segments}<text x="${(x1+x2)/2}" y="${(y1+y2)/2 + (vertical ? 0 : -48)}" text-anchor="middle" class="svg-text strong">${label}</text></g>`;
    };
    let runs = drawRun("Side A", startX, startY, ax2, startY, 0);
    if (state.sideCount >= 2) runs += drawRun("Side B", ax2, startY, ax2, by2, 1);
    if (state.sideCount >= 3) runs += drawRun("Side C", ax2, by2, cx1, by2, 2);
    const deckPlanPoints = [[startX,startY],[ax2,startY]];
    if (state.sideCount >= 2) deckPlanPoints.push([ax2,by2]);
    if (state.sideCount >= 3) deckPlanPoints.push([cx1,by2]);
    const deckPlanPath = deckPlanPoints.map((pt,i)=>`${i ? "L" : "M"} ${pt[0]} ${pt[1]}`).join(" ");
    const dims = `${arrow(startX,startY-70,ax2,startY-70,`A) ${fmt(sideA)}`)}${state.sideCount >= 2 ? arrow(ax2+70,startY,ax2+70,by2,`B) ${fmt(sideB)}`,true) : ""}${state.sideCount >= 3 ? arrow(cx1,by2+70,ax2,by2+70,`C) ${fmt(sideC)}`,true) : ""}`;
    return `<svg viewBox="0 0 ${width} ${height}" preserveAspectRatio="xMidYMid meet" role="img"><defs>${svgDefs().replace(/^<defs>|<\/defs>$/g,"")}<marker id="arrowHead" markerWidth="10" markerHeight="10" refX="5" refY="5" orient="auto-start-reverse"><path d="M0,0 L10,5 L0,10 z" fill="#344842"/></marker></defs><rect width="${width}" height="${height}" fill="#fbfdfc"/><text x="${width/2}" y="54" text-anchor="middle" class="title-text">${state.sideCount} side pin-fixed balustrade plan</text><path d="${deckPlanPath}" fill="none" stroke="#d7d0c2" stroke-width="104" stroke-linecap="square" stroke-linejoin="round" opacity=".38"/><path d="${deckPlanPath}" fill="none" stroke="#ebe5d8" stroke-width="96" stroke-linecap="square" stroke-linejoin="round" opacity=".95"/><text x="${width/2}" y="${by2+116}" text-anchor="middle" class="svg-text small">Round markers show standoff columns. BOM counts every hole on the selected panels.</text>${dims}${runs}<g transform="translate(60 520)"><rect width="440" height="72" rx="14" fill="#fff" stroke="#d8e3df"/><text x="18" y="30" class="svg-text strong">Editing Side ${String.fromCharCode(65+state.activeSide)}</text><text x="18" y="54" class="svg-text small">${pinFixedStandoffName()}</text></g></svg>`;
  }
  function planSvg(){
    if (isPinFixedBalustrade()) return pinFixedPlanSvg();
    if (isSemiBalustrade()) return semiPlanSvg();
    const width = 1080, height = 640;
    const lengths = state.sides.slice(0,state.sideCount).map(s => Number(s.runLength)||0);
    const maxLen = Math.max(...lengths, 1);
    const horizontalScale = Math.min(620 / maxLen, .14);
    const verticalScale = Math.min(350 / maxLen, .14);
    const startX = 270, startY = 165;
    const sideA = lengths[0] || 0;
    const sideB = lengths[1] || 0;
    const sideC = lengths[2] || 0;
    const ax2 = startX + sideA * horizontalScale;
    const by2 = startY + sideB * verticalScale;
    const cx1 = ax2 - sideC * horizontalScale;
    const arrow = (x1,y1,x2,y2,label,below=false) => `<g><line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="#344842" stroke-width="2" marker-start="url(#arrowHead)" marker-end="url(#arrowHead)"/><text x="${(x1+x2)/2}" y="${(y1+y2)/2 + (below ? 28 : -12)}" text-anchor="middle" class="svg-text strong">${label}</text></g>`;
    const drawRun = (label,x1,y1,x2,y2,index) => {
      const active = state.activeSide === index;
      const midX = (x1+x2)/2, midY = (y1+y2)/2;
      const vertical = Math.abs(y2-y1) > Math.abs(x2-x1);
      const sideLayout = withRunLength(lengths[index] || 0, () => selectedLayout(), index);
      const runLength = lengths[index] || 1;
      const ix = (t) => x1 + (x2-x1) * t;
      const iy = (t) => y1 + (y2-y1) * t;
      const labelOffsetX = vertical ? -42 : 0;
      const labelOffsetY = vertical ? 4 : -24;
      const gapOffsetX = vertical ? 34 : 0;
      const gapOffsetY = vertical ? 4 : 34;
      const formatGap = value => Number.isInteger(Number(value)) ? Number(value) : Number(value).toFixed(1);
      const gapLabel = (gapStart, gapEnd, label) => {
        const gx = ix(((gapStart+gapEnd)/2) / runLength);
        const gy = iy(((gapStart+gapEnd)/2) / runLength);
        return `<text x="${gx+gapOffsetX}" y="${gy+gapOffsetY}" text-anchor="middle" class="svg-text small">${formatGap(label)}mm</text>`;
      };
    const leftEndGap = sideLayout.valid && endNeedsGapForSide(index,"left") ? sideLayout.gap : 0;
    const rightEndGap = sideLayout.valid && endNeedsGapForSide(index,"right") ? sideLayout.gap : 0;
      let pos = leftEndGap;
      let segments = leftEndGap ? gapLabel(0,leftEndGap,leftEndGap) : "";
      if (sideLayout.valid) {
        sideLayout.widths.forEach((w,i) => {
          const startT = pos / runLength;
          const endT = (pos + w) / runLength;
          const sx = ix(startT), sy = iy(startT), ex = ix(endT), ey = iy(endT);
          const cx = ix((startT+endT)/2), cy = iy((startT+endT)/2);
          const sp1 = ix(startT + (endT-startT)*.25), sp1y = iy(startT + (endT-startT)*.25);
          const sp2 = ix(startT + (endT-startT)*.75), sp2y = iy(startT + (endT-startT)*.75);
          segments += `<line x1="${sx}" y1="${sy}" x2="${ex}" y2="${ey}" stroke="#dff4f7" stroke-width="${active ? 18 : 14}" stroke-linecap="butt"/><line x1="${sx}" y1="${sy}" x2="${ex}" y2="${ey}" stroke="#6fb8c4" stroke-width="${active ? 4 : 3}" stroke-opacity=".85"/><text x="${cx+labelOffsetX}" y="${cy+labelOffsetY}" text-anchor="middle" class="svg-text small">${w}mm</text>`;
          segments += vertical
            ? `<rect x="${sp1+5}" y="${sp1y-5}" width="7" height="10" rx="2" fill="${finishes[state.finish].colour}" stroke="#40544e"/><rect x="${sp2+5}" y="${sp2y-5}" width="7" height="10" rx="2" fill="${finishes[state.finish].colour}" stroke="#40544e"/>`
            : `<rect x="${sp1-5}" y="${sp1y+5}" width="10" height="7" rx="2" fill="${finishes[state.finish].colour}" stroke="#40544e"/><rect x="${sp2-5}" y="${sp2y+5}" width="10" height="7" rx="2" fill="${finishes[state.finish].colour}" stroke="#40544e"/>`;
          pos += w;
          if (i < sideLayout.widths.length-1) {
            const gapStart = pos;
            const gapEnd = pos + sideLayout.gap;
            segments += gapLabel(gapStart,gapEnd,sideLayout.gap);
            pos += sideLayout.gap;
          }
        });
      if (rightEndGap) segments += gapLabel(pos,pos+rightEndGap,rightEndGap);
      } else {
        segments = `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="#8fc6cf" stroke-width="${active ? 13 : 9}" stroke-opacity=".45" stroke-linecap="butt"/><line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="#6fb8c4" stroke-width="${active ? 3 : 2}" stroke-linecap="square"/>`;
      }
      return `<g data-plan-side="${index}">${segments}<text x="${midX}" y="${midY + (vertical ? 0 : -48)}" text-anchor="middle" class="svg-text strong">${label}</text></g>`;
    };
    let runs = drawRun("Side A", startX, startY, ax2, startY, 0);
    if (state.sideCount >= 2) runs += drawRun("Side B", ax2, startY, ax2, by2, 1);
    if (state.sideCount >= 3) runs += drawRun("Side C", ax2, by2, cx1, by2, 2);
    const wallBlock = (x,y,vertical=true,labelX=0,labelY=0) => vertical
      ? `<g><rect x="${x-6}" y="${y-30}" width="12" height="60" rx="2" fill="#d4d8d5" stroke="#9fa9a6"/><text x="${x+labelX}" y="${y+labelY}" text-anchor="middle" class="svg-text small">Wall</text></g>`
      : `<g><rect x="${x-30}" y="${y-6}" width="60" height="12" rx="2" fill="#d4d8d5" stroke="#9fa9a6"/><text x="${x+labelX}" y="${y+labelY}" text-anchor="middle" class="svg-text small">Wall</text></g>`;
    const startWall = effectiveEnd(0, "left") === "wall" ? wallBlock(startX-20, startY, true, -26, -36) : "";
    const finalWall = (() => {
      if (effectiveEnd(state.sideCount-1, "right") !== "wall") return "";
      if (state.sideCount === 1) return wallBlock(ax2+20, startY, true, 26, -36);
      if (state.sideCount === 2) return wallBlock(ax2, by2+20, false, 0, 34);
      return wallBlock(cx1-20, by2, true, -26, 42);
    })();
    const deckPlanPoints = [[startX,startY],[ax2,startY]];
    if (state.sideCount >= 2) deckPlanPoints.push([ax2,by2]);
    if (state.sideCount >= 3) deckPlanPoints.push([cx1,by2]);
    const deckPlanPath = deckPlanPoints.map((pt,i)=>`${i ? "L" : "M"} ${pt[0]} ${pt[1]}`).join(" ");
    const activeLabel = `Editing Side ${String.fromCharCode(65+state.activeSide)}`;
    const sideNames = state.sides.slice(0,state.sideCount).map((_,i)=>String.fromCharCode(65+i)).join(", ");
    const dims = `${arrow(startX,startY-70,ax2,startY-70,`A) ${fmt(sideA)}`)}${state.sideCount >= 2 ? arrow(ax2+70,startY,ax2+70,by2,`B) ${fmt(sideB)}`,true) : ""}${state.sideCount >= 3 ? arrow(cx1,by2+70,ax2,by2+70,`C) ${fmt(sideC)}`,true) : ""}`;
    return `<svg viewBox="0 0 ${width} ${height}" preserveAspectRatio="xMidYMid meet" role="img"><defs>${svgDefs().replace(/^<defs>|<\/defs>$/g,"")}<marker id="arrowHead" markerWidth="10" markerHeight="10" refX="5" refY="5" orient="auto-start-reverse"><path d="M0,0 L10,5 L0,10 z" fill="#344842"/></marker></defs><rect width="${width}" height="${height}" fill="#fbfdfc"/><text x="${width/2}" y="54" text-anchor="middle" class="title-text">${state.sideCount} side balustrade plan</text><path d="${deckPlanPath}" fill="none" stroke="#d7d0c2" stroke-width="104" stroke-linecap="square" stroke-linejoin="round" opacity=".38"/><path d="${deckPlanPath}" fill="none" stroke="#ebe5d8" stroke-width="96" stroke-linecap="square" stroke-linejoin="round" opacity=".95"/><text x="${width/2}" y="${by2+116}" text-anchor="middle" class="svg-text small">Panel sizes, gaps and spigot positions are shown indicatively. Confirm set-out and edge distances on site.</text>${dims}${startWall}${finalWall}${runs}<g transform="translate(60 520)"><rect width="360" height="72" rx="14" fill="#fff" stroke="#d8e3df"/><text x="18" y="30" class="svg-text strong">${activeLabel}</text><text x="18" y="54" class="svg-text small">Use Side ${sideNames} on the left to edit each run.</text></g></svg>`;
  }
  function materialHtml(lines){
    if (!lines.length) return `<div class="empty">No material list generated.</div>`;
    return `<div class="materials-list">${lines.map(line => {
      const qtyLabel = line.unit === "m2" ? `${line.qty}m2` : `x${line.qty}`;
      return `<div class="mat-line"><div><strong>${line.name}</strong><span>${displaySku(line.sku)}</span>${line.note ? `<p>${line.note}</p>` : ""}</div><b>${qtyLabel}</b></div>`;
    }).join("")}</div>`;
  }
  function cartErrorText(error){
    try {
      const parsed = JSON.parse(error.message || "{}");
      return parsed.description || parsed.message || error.message;
    } catch {
      return error?.message || "Please check the mapped Shopify variant IDs.";
    }
  }
  function cartProperties(line){
    const rule = currentRule();
    const layout = selectedLayout();
    return {
      "Configurator":"Glass balustrade",
      "Layout":`${state.sideCount} side${state.sideCount === 1 ? "" : "s"}`,
      "Run length":fmt(projectRunLength()),
      "Glass":isPinFixedBalustrade() ? rule.glassTitle : rule.title,
      "Handrail":rule.handrail,
      "Fixing":isPinFixedBalustrade() ? pinFixedStandoffName() : state.fixing === "core" ? "Core drill" : "Base plate",
      "Finish":finishes[state.finish].label,
      "Panel layout":layout.valid ? isPinFixedBalustrade() ? `${layout.count} panels, ${layout.standoffCount} standoffs` : `${layout.count} panels, ${layout.gap}mm gaps` : "Review required",
      "SKU":displaySku(line.sku),
      "Design note":cleanText(line.note || line.name)
    };
  }
  function cartItems(lines){
    const missing = [];
    const items = lines.map(line => {
      const mapped = variantMap[line.sku];
      if (!mapped?.variantId) {
        missing.push(line.sku);
        return null;
      }
      return {
        id:Number(mapped.variantId),
        quantity:Math.max(1, Math.round(Number(line.qty) || 1)),
        properties:cartProperties(line)
      };
    }).filter(Boolean);
    return { items, missing };
  }
  async function addProjectToCart(){
    const lines = generateProjectBOM();
    const validation = cartItems(lines);
    const button = $("addCartBtn");
    const status = $("cartStatus");
    if (validation.missing.length || !validation.items.length) {
      if (status) {
        status.innerHTML = validation.items.length
          ? `Some items need variant IDs before checkout:<br>${validation.missing.map(sku => `SKU: ${escapeHtml(displaySku(sku))}`).join("<br>")}`
          : "This configuration requires quote review before checkout.";
      }
      return;
    }
    if (location.protocol === "file:") {
      if (status) status.textContent = `Preview mode: ${validation.items.length} cart lines are ready. Upload to Shopify to add this package to cart.`;
      return;
    }
    if (button) {
      button.disabled = true;
      button.textContent = "Adding...";
    }
    if (status) status.textContent = "Adding balustrade package to cart...";
    try {
      const root = window.Shopify?.routes?.root || "/";
      const response = await fetch(`${root}cart/add.js`, {
        method:"POST",
        headers:{ "Content-Type":"application/json", "Accept":"application/json" },
        body:JSON.stringify({ items:validation.items })
      });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Shopify cart error ${response.status}`);
      }
      if (status) status.textContent = "Added to cart. Redirecting...";
      window.location.href = `${root}cart`;
    } catch (error) {
      console.error("Unable to add balustrade project to cart", error);
      if (status) status.innerHTML = `Unable to add this balustrade package to cart.<br>${escapeHtml(cartErrorText(error))}`;
      if (button) {
        button.disabled = false;
        button.textContent = "Add to cart";
      }
    }
  }
function layoutCards(layouts){
    return layouts.map((layout,i) => {
      const mode = layout.label.toLowerCase().replace(/\s+/g,"");
      const detail = layout.valid
        ? isSemiBalustrade()
          ? `${layout.count} panels &bull; ${layout.count + 1} posts`
          : isPinFixedBalustrade()
          ? `${layout.count} panels &bull; ${layout.standoffCount} standoffs`
          : `${layout.count} panels &bull; ${layout.gap}mm gaps`
        : "Quote review";
      return `<button type="button" data-layout-mode="${mode}" class="${(state.layoutMode === mode || (!i && !layouts.some(l=>l.label.toLowerCase().replace(/\s+/g,"")===state.layoutMode))) ? "active" : ""}"><strong>${layout.label}</strong><span>${detail}</span></button>`;
    }).join("");
  }
function cornerDirectionControlsHtml(){
  if (state.sideCount < 2) return "";
  return Array.from({ length: state.sideCount - 1 }, (_, firstSideIndex) => {
    const firstLabel = String.fromCharCode(65 + firstSideIndex);
    const secondLabel = String.fromCharCode(66 + firstSideIndex);
    const selected = cornerInsideSide(firstSideIndex);
    return `<div class="corner-direction-row">
      <strong>Corner ${firstLabel}-${secondLabel}</strong>
      <div class="seg">
        <button type="button" data-corner-index="${firstSideIndex}" data-inside-side="${firstSideIndex}" class="${selected === firstSideIndex ? "active" : ""}">${firstLabel} sits inside ${secondLabel}</button>
        <button type="button" data-corner-index="${firstSideIndex}" data-inside-side="${firstSideIndex + 1}" class="${selected === firstSideIndex + 1 ? "active" : ""}">${secondLabel} sits inside ${firstLabel}</button>
      </div>
    </div>`;
  }).join("");
}
function semiPtsSummaryHtml(layout){
  const pts = layout?.pts || semiPtsPostSpacingLimit();
  if (!pts.valid) return `<div><strong>PTS check</strong><span>${pts.message}</span></div>`;
  const supportNote = pts.capped ? " Offset handrail capped to 1300mm max." : "";
  const fixingText = state.fixing === "core" ? "Core drilled concrete" : semiBalustrade.siteFixings[pts.siteFixing];
  const windSetting = pts.indoor
    ? `Indoor - external wind-region reductions not applied; using ${pts.spacing}mm max post spacing for this estimate`
    : pts.conservative
    ? `Unsure - conservative A/B assumption: Region ${pts.region}, TC${pts.terrain}, < ${pts.height}m, ${state.windClassification}; confirm site is not Region C/D before ordering`
    : `Region ${pts.region}, TC${pts.terrain}, ${semiBalustrade.installHeights[state.installHeight]}, ${state.windClassification}`;
  return `<div><strong>PTS max post spacing</strong><span>${pts.spacing}mm</span></div><div><strong>Wind/site setting</strong><span>${windSetting}</span></div><div><strong>Fixing method</strong><span>${fixingText}${supportNote}</span></div>${layout?.maxPostSpacing ? `<div><strong>Layout post spacing</strong><span>${Math.round(layout.maxPostSpacing)}mm max</span></div>` : ""}`;
}
function semiInsertSummary(layout){
  if (!layout?.valid || !layout.panelInserts?.length) return "15mm minimum per post pocket";
  const inserts = layout.panelInserts.flatMap(pair => [pair.left, pair.right]);
  const min = Math.round(Math.min(...inserts));
  const max = Math.round(Math.max(...inserts));
  return min === max ? `${min}mm per post pocket` : `${min}-${max}mm by pocket`;
}
function render(){
  syncActiveSide();
  state.extras = state.extras || {};
  state.cornerDirections = state.cornerDirections || { "0-1":1, "1-2":2 };
    if (isSemiBalustrade()) {
      state.spigot = "semiFramelessPosts";
      state.semiGlass = semiBalustrade.glassFamilies[state.semiGlass] ? state.semiGlass : "12toughened";
      state.supportSystem = semiBalustrade.supportSystems[state.supportSystem] ? state.supportSystem : "two_edge_support";
      state.fixing = ["core","base"].includes(state.fixing) ? state.fixing : "base";
      state.semiSiteFixing = semiBalustrade.spacingTables[state.semiSiteFixing] ? state.semiSiteFixing : "uncracked_concrete";
      if (state.fixing === "core" && /^lvl_/.test(state.semiSiteFixing)) state.semiSiteFixing = "uncracked_concrete";
      normaliseSiteState();
      if (semiNeedsLaminatedGlass()) state.semiGlass = "1152laminated";
      if (!["black","white","monument"].includes(state.finish)) state.finish = "black";
      if (state.fixing === "core") {
        state.extras.chemset = false;
        state.extras.concreteFixings = false;
      } else {
        state.extras.groutSika = false;
      }
    } else if (isPinFixedBalustrade()) {
      state.glass = "15";
      state.fixing = "pin_fixed";
      state.spigot = "pinFixedStandoffs";
      normaliseSiteState();
      if (isUnsure(state.installHeight) || (Number(state.installHeight) || 0) > 5) state.installHeight = "5";
      if (!["polished","satin","black","white"].includes(state.finish)) state.finish = "polished";
      state.extras.groutSika = false;
      state.extras.chemset = false;
      state.extras.concreteFixings = false;
    } else if (isHeightLimitedFrameless()) {
      normaliseSiteState();
    } else if (!["polished","satin","black","white"].includes(state.finish)) {
      state.finish = "black";
    }
    if (state.fixing !== "core") state.extras.groutSika = false;
    if (state.fixing !== "base") {
      state.extras.chemset = false;
      state.extras.concreteFixings = false;
    }
    const rule = currentRule();
    const layouts = generateLayouts();
    const layout = selectedLayout();
    const lines = generateProjectBOM();
    const totals = mappedTotal(lines);
    $("heroLength").textContent = fmt(state.runLength);
    $("glassSummary").textContent = isSemiBalustrade() || isPinFixedBalustrade() ? rule.glassTitle : rule.title;
    $("spigotSummary").textContent = isSemiBalustrade()
      ? `${state.fixing === "core" ? "1400mm core-drill" : "1050mm welded base-plated"} posts`
      : isPinFixedBalustrade()
      ? rule.spigotName
      : `${rule.spigotName} ${state.fixing === "core" ? "Core Drill" : "Base Plate"}`;
    $("handrailSummary").textContent = rule.handrail;
    const totalPanels = state.sides.slice(0,state.sideCount).reduce((total, side, index) => total + withRunLength(side.runLength, () => {
      const sideLayout = selectedLayout();
      return sideLayout.valid ? sideLayout.count : 0;
    }, index), 0);
    $("panelSummary").textContent = layout.valid ? `${totalPanels} panels total` : "Review needed";
    const displayTotal = totals.missing.length ? 0 : totals.unpriced.length ? totals.estimatedTotal : totals.total;
    $("priceValue").textContent = displayTotal ? money(displayTotal) : "Quote ready";
    queueVariantPriceRefresh(lines);
  $("layoutOptions").innerHTML = layoutCards(layouts);
  const cornerPanel = $("cornerDirectionPanel");
  if (cornerPanel) {
    cornerPanel.hidden = state.sideCount < 2;
    $("cornerDirectionControls").innerHTML = cornerDirectionControlsHtml();
  }
    $("drawing").innerHTML = state.view === "iso" ? isoSvg(layout) : state.view === "plan" ? planSvg() : elevationSvg(layout);
    $("materials").innerHTML = materialHtml(lines);
    const whyItems = layout.valid ? [...layout.why] : [layout.message];
    $("why").innerHTML = whyItems.map(w => `<li>${w}</li>`).join("");
    const railPlan = isSemiBalustrade() ? null : projectHandrailPlan(rule);
    $("handrailCut").innerHTML = isSemiBalustrade()
      ? `<div><strong>Support system</strong><span>${rule.support.label}</span></div><div><strong>Handrail</strong><span>${rule.handrail}</span></div><div><strong>Glass insertion</strong><span>${semiInsertSummary(layout)}</span></div>${semiPtsSummaryHtml(layout)}`
      : isPinFixedBalustrade()
      ? pinFixedSummaryHtml(layout)
      : layout.valid
      ? `<div><strong>Total handrail</strong><span>${fmt(railPlan.totalLength)}</span></div>` + railPlan.pieces.map(p => `<div><strong>Rail ${p.rail}</strong><span>5800mm stock length supplied</span></div>`).join("") + `<div><strong>Glazing rubber</strong><span>${railPlan.rubberCount} x ${railPlan.rubberLength}mm</span></div><div><strong>Corner joiners</strong><span>${railPlan.cornerJoiners}</span></div><div><strong>Inline joiners</strong><span>${railPlan.inlineJoiners}</span></div>`
      : "";
    const cartLineCount = lines.filter(line => variantMap[line.sku]?.variantId).length;
    $("cartStatus").textContent = !layout.valid
      ? "This configuration requires quote review before checkout."
      : totals.missing.length
      ? `${cartLineCount} product line${cartLineCount === 1 ? "" : "s"} ready. Product mapping requires review for ${totals.missing.length} item${totals.missing.length === 1 ? "" : "s"}.`
      : `${cartLineCount} product line${cartLineCount === 1 ? "" : "s"} ready to add to cart.`;
    document.querySelectorAll("[data-field]").forEach(btn => btn.classList.toggle("active", String(state[btn.dataset.field]) === btn.dataset.value));
    document.querySelectorAll("[data-view]").forEach(btn => btn.classList.toggle("active", state.view === btn.dataset.view));
    $("sideButtons").innerHTML = [0,1,2].map(i => `<button type="button" data-side-index="${i}" ${i >= state.sideCount ? "hidden" : ""} class="${state.activeSide === i ? "active" : ""}">Side ${String.fromCharCode(65+i)}</button>`).join("");
    $("runLength").value = state.runLength;
    $("spigotChoices").innerHTML = compatibleSpigots().map(item => `<button type="button" data-field="spigot" data-value="${item.id}" class="${state.spigot===item.id ? "active" : ""}"><strong>${item.label}</strong><small>${item.sub}</small></button>`).join("");
    const glassField = $("glassField");
    const semiGlassField = $("semiGlassField");
    const supportSystemField = $("supportSystemField");
    const fixingField = $("fixingField");
    const handrailProfileField = $("handrailProfileField");
    const pinStandoffTypeField = $("pinStandoffTypeField");
    const pinStandoffDiameterField = $("pinStandoffDiameterField");
    const pinStandoffDepthField = $("pinStandoffDepthField");
    const pinHandrailField = $("pinHandrailField");
    const semiWindField = $("semiWindField");
    const siteCheckTitle = $("siteCheckTitle");
    const siteLocationField = $("siteLocationField");
    const siteLocationNote = $("siteLocationNote");
    const windRegionField = $("windRegionField");
    const windRegionNote = $("windRegionNote");
    const windClassificationField = $("windClassificationField");
    const terrainCategoryField = $("terrainCategoryField");
    const terrainCategoryNote = $("terrainCategoryNote");
    const installHeightField = $("installHeightField");
    const framelessHeightNote = $("framelessHeightNote");
    const semiSiteFixingField = $("semiSiteFixingField");
    const semiSiteFixingNote = $("semiSiteFixingNote");
    const showSiteCheck = isSemiBalustrade() || isHeightLimitedFrameless();
    if (siteCheckTitle) siteCheckTitle.textContent = isHeightLimitedFrameless() ? "Frameless Height Check" : "Wind / Site Check";
    if (glassField) glassField.style.display = isSemiBalustrade() || isPinFixedBalustrade() ? "none" : "";
    if (semiGlassField) semiGlassField.style.display = isSemiBalustrade() ? "" : "none";
    if (supportSystemField) supportSystemField.style.display = isSemiBalustrade() ? "" : "none";
    if (fixingField) fixingField.style.display = isPinFixedBalustrade() ? "none" : "";
    if (handrailProfileField) handrailProfileField.style.display = isSemiBalustrade() && state.supportSystem !== "offset_handrail" ? "" : "none";
    if (pinStandoffTypeField) pinStandoffTypeField.style.display = isPinFixedBalustrade() ? "" : "none";
    if (pinStandoffDiameterField) pinStandoffDiameterField.style.display = isPinFixedBalustrade() ? "" : "none";
    if (pinStandoffDepthField) pinStandoffDepthField.style.display = isPinFixedBalustrade() ? "" : "none";
    if (pinHandrailField) pinHandrailField.style.display = isPinFixedBalustrade() ? "" : "none";
    if (semiWindField) semiWindField.style.display = showSiteCheck ? "" : "none";
    if (siteLocationField) siteLocationField.style.display = isSemiBalustrade() || isPinFixedBalustrade() ? "" : "none";
    if (siteLocationNote) {
      siteLocationNote.style.display = isSemiBalustrade() || isPinFixedBalustrade() ? "" : "none";
      siteLocationNote.textContent = state.siteLocation === "indoor"
        ? "Indoor removes external wind-region reductions for this estimate. Final suitability, fixing and compliance still need to be confirmed before ordering."
        : "Outdoor applies wind-region, terrain and height guardrails where the selected system uses them.";
    }
    if (windRegionField) windRegionField.style.display = isSemiBalustrade() && state.siteLocation !== "indoor" ? "" : "none";
    if (windRegionNote) windRegionNote.style.display = isSemiBalustrade() && state.siteLocation !== "indoor" ? "" : "none";
    if (windClassificationField) windClassificationField.style.display = isSemiBalustrade() && state.siteLocation !== "indoor" ? "" : "none";
    if (terrainCategoryField) terrainCategoryField.style.display = isSemiBalustrade() && state.siteLocation !== "indoor" ? "" : "none";
    if (terrainCategoryNote) terrainCategoryNote.style.display = isSemiBalustrade() && state.siteLocation !== "indoor" ? "" : "none";
    if (installHeightField) installHeightField.style.display = isSemiBalustrade() ? "" : "none";
    if (framelessHeightNote) framelessHeightNote.style.display = isHeightLimitedFrameless() ? "" : "none";
    if (semiSiteFixingField) semiSiteFixingField.style.display = isSemiBalustrade() && state.fixing === "base" ? "" : "none";
    if (semiSiteFixingNote) semiSiteFixingNote.style.display = isSemiBalustrade() && state.fixing === "base" ? "" : "none";
    document.querySelectorAll('[data-field="semiSiteFixing"][data-value^="lvl_"]').forEach(btn => { btn.hidden = isSemiBalustrade() && state.fixing === "core"; });
    $("spigotField").style.display = isSemiBalustrade() || isPinFixedBalustrade() || state.glass === "15" ? "none" : "";
    document.querySelectorAll('[data-field="finish"][data-value="polished"],[data-field="finish"][data-value="satin"]').forEach(btn => { btn.hidden = isSemiBalustrade(); });
    document.querySelectorAll('[data-field="finish"][data-value="monument"]').forEach(btn => { btn.hidden = !isSemiBalustrade(); });
    document.querySelectorAll('[data-field="pinStandoffDepth"]').forEach(btn => {
      btn.hidden = !isPinFixedBalustrade() || !pinFixedBalustrade.standoffs[state.pinStandoffType]?.[state.pinStandoffDiameter]?.[btn.dataset.value];
    });
    document.querySelectorAll('[data-field="finish"]').forEach(btn => {
      if (!isPinFixedBalustrade() || btn.dataset.value === "monument") return;
      const options = pinFixedBalustrade.standoffs[state.pinStandoffType]?.[state.pinStandoffDiameter]?.[state.pinStandoffDepth] || {};
      btn.hidden = !options[btn.dataset.value]
        || (state.pinHandrail === "series35" && btn.dataset.value === "polished");
    });
    const extrasOptions = $("extrasOptions");
    if (extrasOptions) extrasOptions.innerHTML = "";
    if ($("extrasModal")?.classList.contains("open")) renderExtrasModal();
  }
  function share(){
    const payload = btoa(unescape(encodeURIComponent(JSON.stringify({ version:1, configuratorType:"balustrade", project:state }))));
    const url = new URL(location.href);
    url.searchParams.set("config", payload);
    $("shareUrl").hidden = false;
    $("shareUrl").value = url.toString();
    navigator.clipboard?.writeText(url.toString()).catch(()=>{});
    $("shareStatus").hidden = false;
    $("shareStatus").textContent = "Project link copied.";
  }
  function restore(){
    try {
      const encoded = new URLSearchParams(location.search).get("config");
      if (!encoded) return;
      const saved = JSON.parse(decodeURIComponent(escape(atob(encoded))));
      if (saved?.configuratorType !== "balustrade") return;
      Object.assign(state, saved.project || {});
      clampRun();
    } catch {}
  }
  document.addEventListener("click",(e)=>{
    const field = e.target.closest("[data-field]");
    const view = e.target.closest("[data-view]");
    const layoutMode = e.target.closest("[data-layout-mode]");
    const sideBtn = e.target.closest("[data-side-index]");
    const planSide = e.target.closest("[data-plan-side]");
    const extra = e.target.closest("[data-extra]");
    const addCart = e.target.closest("#addCartBtn");
    const extrasClose = e.target.closest("[data-extras-close]");
    const extrasSkip = e.target.closest("[data-extras-skip]");
    const extrasConfirm = e.target.closest("[data-extras-confirm]");
    const cornerDirection = e.target.closest("[data-corner-index][data-inside-side]");
    if(cornerDirection){
      const firstSideIndex = Number(cornerDirection.dataset.cornerIndex);
      const insideSideIndex = Number(cornerDirection.dataset.insideSide);
      state.cornerDirections = state.cornerDirections || {};
      state.cornerDirections[cornerKey(firstSideIndex)] = insideSideIndex;
      render();
      return;
    }
    if (addCart) { openExtrasModal(); return; }
    if (extrasClose || e.target.id === "extrasModal") { closeExtrasModal(); return; }
    if (extrasSkip) {
      clearOptionalExtras();
      closeExtrasModal();
      render();
      addProjectToCart();
      return;
    }
    if (extrasConfirm) {
      closeExtrasModal();
      render();
      addProjectToCart();
      return;
    }
    if (extra) {
      state.extras = state.extras || {};
      state.extras[extra.dataset.extra] = !state.extras[extra.dataset.extra];
      renderExtrasModal();
      render();
      return;
    }
    if (field) {
      field.blur();
      document.querySelectorAll(".system-choice.preview-open").forEach(btn => btn.classList.remove("preview-open"));
      if (field.dataset.field === "sideCount") {
        state.sideCount = Math.max(1, Math.min(3, Number(field.dataset.value)||1));
        if (state.activeSide >= state.sideCount) state.activeSide = state.sideCount - 1;
      } else {
        state[field.dataset.field] = field.dataset.value;
      }
      if (field.dataset.field === "system" && field.dataset.value === "semi_frameless_balustrade") {
        state.spigot = "semiFramelessPosts";
        state.fixing = "base";
        if (!["black","white","monument"].includes(state.finish)) state.finish = "black";
        if (semiNeedsLaminatedGlass()) state.semiGlass = "1152laminated";
      }
      if (field.dataset.field === "system" && field.dataset.value === "frameless_pin_fixed_15mm") {
        state.glass = "15";
        state.spigot = "pinFixedStandoffs";
        state.fixing = "pin_fixed";
        state.pinStandoffType = state.pinStandoffType || "fixed";
        state.pinStandoffDiameter = state.pinStandoffDiameter || "50";
        state.pinStandoffDepth = state.pinStandoffDepth || "30";
        state.pinHandrail = state.pinHandrail || "deluxe";
        if (!["polished","satin","black","white"].includes(state.finish)) state.finish = "polished";
        if (isUnsure(state.installHeight) || (Number(state.installHeight) || 0) > 5) state.installHeight = "5";
      }
      if (field.dataset.field === "system" && field.dataset.value !== "semi_frameless_balustrade" && field.dataset.value !== "frameless_pin_fixed_15mm") {
        if (!rules[`12-${state.spigot}`] && state.glass !== "15") state.spigot = "nova";
        if (!["polished","satin","black","white"].includes(state.finish)) state.finish = "black";
        if (isHeightLimitedFrameless() && (isUnsure(state.installHeight) || (Number(state.installHeight) || 0) > 5)) state.installHeight = "5";
      }
      if (field.dataset.field === "pinStandoffType" || field.dataset.field === "pinStandoffDiameter") {
        const depths = Object.keys(pinFixedBalustrade.standoffs[state.pinStandoffType]?.[state.pinStandoffDiameter] || {});
        if (!depths.includes(state.pinStandoffDepth)) state.pinStandoffDepth = depths[0] || "30";
      }
      if (["pinStandoffType","pinStandoffDiameter","pinStandoffDepth","pinHandrail"].includes(field.dataset.field)) {
        const options = pinFixedBalustrade.standoffs[state.pinStandoffType]?.[state.pinStandoffDiameter]?.[state.pinStandoffDepth] || {};
        if (!options[state.finish]) state.finish = Object.keys(options)[0] || "polished";
        if (field.dataset.field === "pinHandrail" && state.pinHandrail === "deluxe" && ["black","white"].includes(state.finish)) state.finish = "polished";
        if (state.pinHandrail === "series35" && state.finish === "polished") state.finish = "satin";
      }
      if (field.dataset.field === "glass" && field.dataset.value === "15") {
        state.spigot = "madridDeluxe";
        if (isUnsure(state.installHeight) || (Number(state.installHeight) || 0) > 5) state.installHeight = "5";
      }
      if (field.dataset.field === "glass" && field.dataset.value === "12" && state.spigot === "madridDeluxe") state.spigot = "nova";
      if (field.dataset.field === "spigot" && ["madrid","nova"].includes(field.dataset.value) && (isUnsure(state.installHeight) || (Number(state.installHeight) || 0) > 5)) state.installHeight = "5";
      render();
    }
    if (sideBtn) {
      state.activeSide = Math.max(0, Math.min(state.sideCount-1, Number(sideBtn.dataset.sideIndex)||0));
      syncActiveSide();
      render();
    }
    if (planSide) {
      state.activeSide = Math.max(0, Math.min(state.sideCount-1, Number(planSide.dataset.planSide)||0));
      syncActiveSide();
      render();
    }
    if (view) { state.view = view.dataset.view; render(); }
    if (layoutMode) { state.layoutMode = layoutMode.dataset.layoutMode; render(); }
    if (e.target.closest("#shareBtn")) share();
    if (e.target.closest("#printBtn")) window.print();
    if (e.target.closest("#quoteBtn")) {
      const sides = state.sides.slice(0,state.sideCount).map((s,i)=>`Side ${String.fromCharCode(65+i)}: ${fmt(s.runLength)}`).join("\n");
      const rule = currentRule();
      const hardware = isSemiBalustrade() ? `Hardware: 50 x 50mm ${state.fixing === "core" ? "core-drill" : "welded base-plated"} semi-frameless posts` : isPinFixedBalustrade() ? `Hardware: ${pinFixedStandoffName()}` : `Spigot: ${rule.spigotName} ${state.fixing}`;
      const body = encodeURIComponent(`Glass House AU Balustrade Quote Request\n\nLayout: ${state.sideCount} side${state.sideCount === 1 ? "" : "s"}\n${sides}\n\nActive side shown: Side ${String.fromCharCode(65+state.activeSide)}\nSystem: ${rule.title}\nGlass: ${isSemiBalustrade() || isPinFixedBalustrade() ? rule.glassTitle : rule.title}\nSupport: ${isSemiBalustrade() ? rule.support.label : isPinFixedBalustrade() ? "Frameless pin-fixed standoff system" : "Frameless spigot system"}\n${hardware}\nHandrail: ${rule.handrail}\nStart of Side A: ${state.leftEnd}\nFinal outside end: ${state.rightEnd}\n\nMaterials:\n${generateProjectBOM().map(l => `${l.unit === "m2" ? `${l.qty}m2` : `${l.qty} x`} ${displaySku(l.sku)} - ${l.name}`).join("\n")}`);
      location.href = `mailto:hello@glasshousea.com?subject=Balustrade quote request&body=${body}`;
    }
  });
  document.addEventListener("input",(e)=>{
    if (e.target.id === "runLength") {
      const value = Number(e.target.value);
      if (!Number.isFinite(value)) return;
      state.runLength = value;
      if (value >= 600) {
        clampRun();
        e.target.value = state.runLength;
        render();
      }
    }
  });
  document.addEventListener("change",(e)=>{
    if (e.target.id === "runLength") {
      state.runLength = Number(e.target.value);
      clampRun();
      e.target.value = state.runLength;
      render();
    }
  });
  restore();
  installPreviewGuard();
  installPreviewHover();
  window.GHA_BALUSTRADE = { state, generateLayouts, generateBOM, generateProjectBOM, projectGlassAreaM2 };
  render();
})();
